(() => {

    function shouldIgnore(element) {
        // Check if wp_dark_mode_json exists
        if (typeof wp_dark_mode_json === 'undefined') {
            return false;
        }

        // If element has .wp-dark-mode-ignore class.
        if ( element && element.classList && element.classList.contains('wp-dark-mode-ignore') ) {
            return true;
        }
        
        // Create the selector string safely
        const excludedSelectors = '.wp-dark-mode-ignore' + (wp_dark_mode_json.excluded_elements ? ', ' + wp_dark_mode_json.excluded_elements : '');
        
        try {
            // Get all excluded elements
            const excludedElements = document.querySelectorAll(excludedSelectors);
            
            
            // Check if the element is in excluded elements or is a child of any
            for (const excludedElement of excludedElements) {
                if ( excludedElement ) {
                    excludedElement.classList.add('wp-dark-mode-ignore');
                }
                if (excludedElement == element || excludedElement.contains(element)) {
                    return true;
                }
            }
        } catch (error) {

        }
        
        return false;
    }


    var e = {
            35: function(e, t) {
                var n, r, a, o, i;

                function u(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }))), n.push.apply(n, r)
                    }
                    return n
                }

                function c(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? u(Object(n), !0).forEach((function(t) {
                            s(e, t, n[t])
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                        }))
                    }
                    return e
                }

                function s(e, t, n) {
                    return (t = h(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e
                }

                function l(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }

                function f(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, h(r.key), r)
                    }
                }

                function d(e, t, n) {
                    return t && f(e.prototype, t), n && f(e, n), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e
                }

                function h(e) {
                    var t = function(e, t) {
                        if ("object" != k(e) || !e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, t || "default");
                            if ("object" != k(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return ("string" === t ? String : Number)(e)
                    }(e, "string");
                    return "symbol" == k(t) ? t : String(t)
                }

                function p(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, a, o, i, u = [],
                                c = !0,
                                s = !1;
                            try {
                                if (o = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    c = !1
                                } else
                                    for (; !(c = (r = o.call(n)).done) && (u.push(r.value), u.length !== t); c = !0);
                            } catch (e) {
                                s = !0, a = e
                            } finally {
                                try {
                                    if (!c && null != n.return && (i = n.return(), Object(i) !== i)) return
                                } finally {
                                    if (s) throw a
                                }
                            }
                            return u
                        }
                    }(e, t) || g(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function v(e) {
                    return function(e) {
                        if (Array.isArray(e)) return b(e)
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
                    }(e) || g(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function m(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = g(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0,
                                a = function() {};
                            return {
                                s: a,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    }
                                },
                                e: function(e) {
                                    throw e
                                },
                                f: a
                            }
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }
                    var o, i = !0,
                        u = !1;
                    return {
                        s: function() {
                            n = n.call(e)
                        },
                        n: function() {
                            var e = n.next();
                            return i = e.done, e
                        },
                        e: function(e) {
                            u = !0, o = e
                        },
                        f: function() {
                            try {
                                i || null == n.return || n.return()
                            } finally {
                                if (u) throw o
                            }
                        }
                    }
                }

                function g(e, t) {
                    if (e) {
                        if ("string" == typeof e) return b(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? b(e, t) : void 0
                    }
                }

                function b(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
                    return r
                }

                function y() {
                    "use strict";
                    y = function() {
                        return t
                    };
                    var e, t = {},
                        n = Object.prototype,
                        r = n.hasOwnProperty,
                        a = Object.defineProperty || function(e, t, n) {
                            e[t] = n.value
                        },
                        o = "function" == typeof Symbol ? Symbol : {},
                        i = o.iterator || "@@iterator",
                        u = o.asyncIterator || "@@asyncIterator",
                        c = o.toStringTag || "@@toStringTag";

                    function s(e, t, n) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t]
                    }
                    try {
                        s({}, "")
                    } catch (e) {
                        s = function(e, t, n) {
                            return e[t] = n
                        }
                    }

                    function l(e, t, n, r) {
                        var o = t && t.prototype instanceof g ? t : g,
                            i = Object.create(o.prototype),
                            u = new V(r || []);
                        return a(i, "_invoke", {
                            value: T(e, n, u)
                        }), i
                    }

                    function f(e, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, n)
                            }
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            }
                        }
                    }
                    t.wrap = l;
                    var d = "suspendedStart",
                        h = "suspendedYield",
                        p = "executing",
                        v = "completed",
                        m = {};

                    function g() {}

                    function b() {}

                    function w() {}
                    var S = {};
                    s(S, i, (function() {
                        return this
                    }));
                    var E = Object.getPrototypeOf,
                        x = E && E(E(O([])));
                    x && x !== n && r.call(x, i) && (S = x);
                    var C = w.prototype = g.prototype = Object.create(S);

                    function _(e) {
                        ["next", "throw", "return"].forEach((function(t) {
                            s(e, t, (function(e) {
                                return this._invoke(t, e)
                            }))
                        }))
                    }

                    function A(e, t) {
                        function n(a, o, i, u) {
                            var c = f(e[a], e, o);
                            if ("throw" !== c.type) {
                                var s = c.arg,
                                    l = s.value;
                                return l && "object" == k(l) && r.call(l, "__await") ? t.resolve(l.__await).then((function(e) {
                                    n("next", e, i, u)
                                }), (function(e) {
                                    n("throw", e, i, u)
                                })) : t.resolve(l).then((function(e) {
                                    s.value = e, i(s)
                                }), (function(e) {
                                    return n("throw", e, i, u)
                                }))
                            }
                            u(c.arg)
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e, r) {
                                function a() {
                                    return new t((function(t, a) {
                                        n(e, r, t, a)
                                    }))
                                }
                                return o = o ? o.then(a, a) : a()
                            }
                        })
                    }

                    function T(t, n, r) {
                        var a = d;
                        return function(o, i) {
                            if (a === p) throw new Error("Generator is already running");
                            if (a === v) {
                                if ("throw" === o) throw i;
                                return {
                                    value: e,
                                    done: !0
                                }
                            }
                            for (r.method = o, r.arg = i;;) {
                                var u = r.delegate;
                                if (u) {
                                    var c = R(u, r);
                                    if (c) {
                                        if (c === m) continue;
                                        return c
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if (a === d) throw a = v, r.arg;
                                    r.dispatchException(r.arg)
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                a = p;
                                var s = f(t, n, r);
                                if ("normal" === s.type) {
                                    if (a = r.done ? v : h, s.arg === m) continue;
                                    return {
                                        value: s.arg,
                                        done: r.done
                                    }
                                }
                                "throw" === s.type && (a = v, r.method = "throw", r.arg = s.arg)
                            }
                        }
                    }

                    function R(t, n) {
                        var r = n.method,
                            a = t.iterator[r];
                        if (a === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, R(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), m;
                        var o = f(a, t.iterator, n.arg);
                        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, m;
                        var i = o.arg;
                        return i ? i.done ? (n[t.resultName] = i.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, m) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, m)
                    }

                    function L(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t)
                    }

                    function M(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t
                    }

                    function V(e) {
                        this.tryEntries = [{
                            tryLoc: "root"
                        }], e.forEach(L, this), this.reset(!0)
                    }

                    function O(t) {
                        if (t || "" === t) {
                            var n = t[i];
                            if (n) return n.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var a = -1,
                                    o = function n() {
                                        for (; ++a < t.length;)
                                            if (r.call(t, a)) return n.value = t[a], n.done = !1, n;
                                        return n.value = e, n.done = !0, n
                                    };
                                return o.next = o
                            }
                        }
                        throw new TypeError(k(t) + " is not iterable")
                    }
                    return b.prototype = w, a(C, "constructor", {
                        value: w,
                        configurable: !0
                    }), a(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = s(w, c, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name))
                    }, t.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, w) : (e.__proto__ = w, s(e, c, "GeneratorFunction")), e.prototype = Object.create(C), e
                    }, t.awrap = function(e) {
                        return {
                            __await: e
                        }
                    }, _(A.prototype), s(A.prototype, u, (function() {
                        return this
                    })), t.AsyncIterator = A, t.async = function(e, n, r, a, o) {
                        void 0 === o && (o = Promise);
                        var i = new A(l(e, n, r, a), o);
                        return t.isGeneratorFunction(n) ? i : i.next().then((function(e) {
                            return e.done ? e.value : i.next()
                        }))
                    }, _(C), s(C, c, "Generator"), s(C, i, (function() {
                        return this
                    })), s(C, "toString", (function() {
                        return "[object Generator]"
                    })), t.keys = function(e) {
                        var t = Object(e),
                            n = [];
                        for (var r in t) n.push(r);
                        return n.reverse(),
                            function e() {
                                for (; n.length;) {
                                    var r = n.pop();
                                    if (r in t) return e.value = r, e.done = !1, e
                                }
                                return e.done = !0, e
                            }
                    }, t.values = O, V.prototype = {
                        constructor: V,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(M), !t)
                                for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e)
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var n = this;

                            function a(r, a) {
                                return u.type = "throw", u.arg = t, n.next = r, a && (n.method = "next", n.arg = e), !!a
                            }
                            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                                var i = this.tryEntries[o],
                                    u = i.completion;
                                if ("root" === i.tryLoc) return a("end");
                                if (i.tryLoc <= this.prev) {
                                    var c = r.call(i, "catchLoc"),
                                        s = r.call(i, "finallyLoc");
                                    if (c && s) {
                                        if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return a(i.finallyLoc)
                                    } else if (c) {
                                        if (this.prev < i.catchLoc) return a(i.catchLoc, !0)
                                    } else {
                                        if (!s) throw new Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return a(i.finallyLoc)
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                                var a = this.tryEntries[n];
                                if (a.tryLoc <= this.prev && r.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
                                    var o = a;
                                    break
                                }
                            }
                            o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var i = o ? o.completion : {};
                            return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, m) : this.complete(i)
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m
                        },
                        finish: function(e) {
                            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), M(n), m
                            }
                        },
                        catch: function(e) {
                            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var a = r.arg;
                                        M(n)
                                    }
                                    return a
                                }
                            }
                            throw new Error("illegal catch attempt")
                        },
                        delegateYield: function(t, n, r) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = e), m
                        }
                    }, t
                }

                function w(e, t, n, r, a, o, i) {
                    try {
                        var u = e[o](i),
                            c = u.value
                    } catch (e) {
                        return void n(e)
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, a)
                }

                function S(e) {
                    return function() {
                        var t = this,
                            n = arguments;
                        return new Promise((function(r, a) {
                            var o = e.apply(t, n);

                            function i(e) {
                                w(o, r, a, i, u, "next", e)
                            }

                            function u(e) {
                                w(o, r, a, i, u, "throw", e)
                            }
                            i(void 0)
                        }))
                    }
                }

                function k(e) {
                    return k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                    }, k(e)
                }
                o = this, i = function(e) {
                    "use strict";
                    var t, n, r, a, o, i, u, s, f;
                    ! function(e) {
                        e.GET_DATA = "ui-bg-get-data", e.GET_DEVTOOLS_DATA = "ui-bg-get-devtools-data", e.SUBSCRIBE_TO_CHANGES = "ui-bg-subscribe-to-changes", e.UNSUBSCRIBE_FROM_CHANGES = "ui-bg-unsubscribe-from-changes", e.CHANGE_SETTINGS = "ui-bg-change-settings", e.SET_THEME = "ui-bg-set-theme", e.TOGGLE_ACTIVE_TAB = "ui-bg-toggle-active-tab", e.MARK_NEWS_AS_READ = "ui-bg-mark-news-as-read", e.MARK_NEWS_AS_DISPLAYED = "ui-bg-mark-news-as-displayed", e.LOAD_CONFIG = "ui-bg-load-config", e.APPLY_DEV_DYNAMIC_THEME_FIXES = "ui-bg-apply-dev-dynamic-theme-fixes", e.RESET_DEV_DYNAMIC_THEME_FIXES = "ui-bg-reset-dev-dynamic-theme-fixes", e.APPLY_DEV_INVERSION_FIXES = "ui-bg-apply-dev-inversion-fixes", e.RESET_DEV_INVERSION_FIXES = "ui-bg-reset-dev-inversion-fixes", e.APPLY_DEV_STATIC_THEMES = "ui-bg-apply-dev-static-themes", e.RESET_DEV_STATIC_THEMES = "ui-bg-reset-dev-static-themes", e.COLOR_SCHEME_CHANGE = "ui-bg-color-scheme-change", e.HIDE_HIGHLIGHTS = "ui-bg-hide-highlights"
                    }(t || (t = {})),
                    function(e) {
                        e.CHANGES = "bg-ui-changes"
                    }(n || (n = {})),
                    function(e) {
                        e.CSS_UPDATE = "debug-bg-ui-css-update", e.UPDATE = "debug-bg-ui-update"
                    }(r || (r = {})),
                    function(e) {
                        e.ADD_CSS_FILTER = "bg-cs-add-css-filter", e.ADD_DYNAMIC_THEME = "bg-cs-add-dynamic-theme", e.ADD_STATIC_THEME = "bg-cs-add-static-theme", e.ADD_SVG_FILTER = "bg-cs-add-svg-filter", e.CLEAN_UP = "bg-cs-clean-up", e.FETCH_RESPONSE = "bg-cs-fetch-response", e.UNSUPPORTED_SENDER = "bg-cs-unsupported-sender"
                    }(a || (a = {})),
                    function(e) {
                        e.RELOAD = "debug-bg-cs-reload"
                    }(o || (o = {})),
                    function(e) {
                        e.COLOR_SCHEME_CHANGE = "cs-bg-color-scheme-change", e.DARK_THEME_DETECTED = "cs-bg-dark-theme-detected", e.DARK_THEME_NOT_DETECTED = "cs-bg-dark-theme-not-detected", e.FETCH = "cs-bg-fetch", e.DOCUMENT_CONNECT = "cs-bg-document-connect", e.DOCUMENT_FORGET = "cs-bg-document-forget", e.DOCUMENT_FREEZE = "cs-bg-document-freeze", e.DOCUMENT_RESUME = "cs-bg-document-resume"
                    }(i || (i = {})),
                    function(e) {
                        e.LOG = "debug-cs-bg-log"
                    }(u || (u = {})),
                    function(e) {
                        e.EXPORT_CSS_RESPONSE = "cs-ui-export-css-response"
                    }(s || (s = {})),
                    function(e) {
                        e.EXPORT_CSS = "ui-cs-export-css"
                    }(f || (f = {}));
                    var h = "undefined" != typeof navigator,
                        g = h ? navigator.userAgentData && Array.isArray(navigator.userAgentData.brands) ? navigator.userAgentData.brands.map((function(e) {
                            return "".concat(e.brand.toLowerCase(), " ").concat(e.version)
                        })).join(" ") : navigator.userAgent.toLowerCase() : "some useragent",
                        b = h ? navigator.userAgentData && "string" == typeof navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() : navigator.platform.toLowerCase() : "some platform",
                        w = g.includes("chrome") || g.includes("chromium"),
                        E = g.includes("firefox") || g.includes("thunderbird") || g.includes("librewolf"),
                        x = g.includes("safari") && !w,
                        C = b.startsWith("win"),
                        _ = b.startsWith("mac");
                    h && navigator.userAgentData ? navigator.userAgentData.mobile : g.includes("mobile");
                    var A, T = "function" == typeof ShadowRoot,
                        R = "function" == typeof MediaQueryList && "function" == typeof MediaQueryList.prototype.addEventListener;
                    (A = g.match(/chrom(?:e|ium)(?:\/| )([^ ]+)/)) && A[1] && A[1],
                        function() {
                            var e = g.match(/(?:firefox|librewolf)(?:\/| )([^ ]+)/);
                            e && e[1] && e[1]
                        }();
                    var L = function() {
                            try {
                                return document.querySelector(":defined"), !0
                            } catch (e) {
                                return !1
                            }
                        }(),
                        M = function() {
                            try {
                                if ("undefined" == typeof document) return !1;
                                var e = document.createElement("div");
                                return !(!e || "object" !== k(e.style) || "string" != typeof e.style.colorScheme && (e.setAttribute("style", "color-scheme: dark"), "dark" !== e.style.colorScheme))
                            } catch (e) {
                                return !1
                            }
                        }();

                    function V(e, t, n) {
                        return O.apply(this, arguments)
                    }

                    function O() {
                        return (O = S(y().mark((function e(t, n, r) {
                            var a;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, fetch(t, {
                                            cache: "force-cache",
                                            credentials: "omit",
                                            referrer: r
                                        });
                                    case 2:
                                        if (a = e.sent, !(E && "text/css" === n && t.startsWith("moz-extension://") && t.endsWith(".css"))) {
                                            e.next = 5;
                                            break
                                        }
                                        return e.abrupt("return", a);
                                    case 5:
                                        if (!n || a.headers.get("Content-Type").startsWith(n)) {
                                            e.next = 7;
                                            break
                                        }
                                        throw new Error("Mime type mismatch when loading ".concat(t));
                                    case 7:
                                        if (a.ok) {
                                            e.next = 9;
                                            break
                                        }
                                        throw new Error("Unable to load ".concat(t, " ").concat(a.status, " ").concat(a.statusText));
                                    case 9:
                                        return e.abrupt("return", a);
                                    case 10:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function P(e, t) {
                        return D.apply(this, arguments)
                    }

                    function D() {
                        return (D = S(y().mark((function e(t, n) {
                            var r;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, V(t, n);
                                    case 2:
                                        return r = e.sent, e.next = 5, j(r);
                                    case 5:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function N(e, t) {
                        return F.apply(this, arguments)
                    }

                    function F() {
                        return (F = S(y().mark((function e(t, n) {
                            var r;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, V(t, n);
                                    case 2:
                                        return r = e.sent, e.next = 5, r.blob();
                                    case 5:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function j(e) {
                        return I.apply(this, arguments)
                    }

                    function I() {
                        return (I = S(y().mark((function e(t) {
                            var n, r;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, t.blob();
                                    case 2:
                                        return n = e.sent, e.next = 5, new Promise((function(e) {
                                            var t = new FileReader;
                                            t.onloadend = function() {
                                                return e(t.result)
                                            }, t.readAsDataURL(n)
                                        }));
                                    case 5:
                                        return r = e.sent, e.abrupt("return", r);
                                    case 7:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function W(e, t, n) {
                        return q.apply(this, arguments)
                    }

                    function q() {
                        return (q = S(y().mark((function e(t, n, r) {
                            var a;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, V(t, n, r);
                                    case 2:
                                        return a = e.sent, e.next = 5, a.text();
                                    case 5:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    var B = function() {
                            var e = S(y().mark((function e(t) {
                                return y().wrap((function(e) {
                                    for (;;) switch (e.prev = e.next) {
                                        case 0:
                                            return e.abrupt("return", null);
                                        case 1:
                                        case "end":
                                            return e.stop()
                                    }
                                }), e)
                            })));
                            return function(t) {
                                return e.apply(this, arguments)
                            }
                        }(),
                        U = B;

                    function H(e) {
                        return G.apply(this, arguments)
                    }

                    function G() {
                        return (G = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, U(t);
                                    case 2:
                                        return e.abrupt("return", e.sent);
                                    case 3:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    window.chrome || (window.chrome = {}), chrome.runtime || (chrome.runtime = {});
                    var $, z, Q = new Set;

                    function K() {
                        return Y.apply(this, arguments)
                    }

                    function Y() {
                        return Y = S(y().mark((function e() {
                            var t, n, r, o, u, c, s, l, f, d = arguments;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        for (t = d.length, n = new Array(t), r = 0; r < t; r++) n[r] = d[r];
                                        if (!n[0] || n[0].type !== i.FETCH) {
                                            e.next = 23;
                                            break
                                        }
                                        return o = n[0].id, e.prev = 3, u = n[0].data, c = u.url, s = u.responseType, e.next = 7, H(c);
                                    case 7:
                                        if (l = e.sent, "data-url" !== s) {
                                            e.next = 14;
                                            break
                                        }
                                        return e.next = 11, j(l);
                                    case 11:
                                        f = e.sent, e.next = 17;
                                        break;
                                    case 14:
                                        return e.next = 16, l.text();
                                    case 16:
                                        f = e.sent;
                                    case 17:
                                        Q.forEach((function(e) {
                                            return e({
                                                type: a.FETCH_RESPONSE,
                                                data: f,
                                                error: null,
                                                id: o
                                            })
                                        })), e.next = 23;
                                        break;
                                    case 20:
                                        e.prev = 20, e.t0 = e.catch(3), Q.forEach((function(t) {
                                            return t({
                                                type: a.FETCH_RESPONSE,
                                                data: null,
                                                error: e.t0,
                                                id: o
                                            })
                                        }));
                                    case 23:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [3, 20]
                            ])
                        }))), Y.apply(this, arguments)
                    }

                    function X(e) {
                        Q.add(e)
                    }
                    if ("function" == typeof chrome.runtime.sendMessage) {
                        var J = chrome.runtime.sendMessage;
                        chrome.runtime.sendMessage = function() {
                            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                            K.apply(void 0, t), J.apply(chrome.runtime, t)
                        }
                    } else chrome.runtime.sendMessage = K;
                    if (chrome.runtime.onMessage || (chrome.runtime.onMessage = {}), "function" == typeof chrome.runtime.onMessage.addListener) {
                        var Z = chrome.runtime.onMessage.addListener;
                        chrome.runtime.onMessage.addListener = function() {
                            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                            X(t[0]), Z.apply(chrome.runtime.onMessage, t)
                        }
                    } else chrome.runtime.onMessage.addListener = function() {
                        return X(arguments.length <= 0 ? void 0 : arguments[0])
                    };
                    ! function(e) {
                        e.cssFilter = "cssFilter", e.svgFilter = "svgFilter", e.staticTheme = "staticTheme", e.dynamicTheme = "dynamicTheme"
                    }($ || ($ = {})),
                    function(e) {
                        e.NONE = "", e.TIME = "time", e.SYSTEM = "system", e.LOCATION = "location"
                    }(z || (z = {}));
                    var ee = {
                            background: "#181a1b",
                            text: "#e8e6e3"
                        },
                        te = {
                            background: "#dcdad7",
                            text: "#181a1b"
                        },
                        ne = {
                            mode: 1,
                            brightness: 100,
                            contrast: 100,
                            grayscale: 0,
                            sepia: 0,
                            useFont: !1,
                            fontFamily: _ ? "Helvetica Neue" : C ? "Segoe UI" : "Open Sans",
                            textStroke: 0,
                            engine: $.dynamicTheme,
                            stylesheet: "",
                            darkSchemeBackgroundColor: ee.background,
                            darkSchemeTextColor: ee.text,
                            lightSchemeBackgroundColor: te.background,
                            lightSchemeTextColor: te.text,
                            scrollbarColor: null,
                            selectionColor: "auto",
                            styleSystemControls: !M,
                            lightColorScheme: "Default",
                            darkColorScheme: "Default",
                            immediateModify: !0,
                            excludes: ".wp-dark-mode-ignore"
                        };

                    function re(e, t) {
                        if (function(e) {
                                return null != e.length
                            }(e))
                            for (var n = 0, r = e.length; n < r; n++) t(e[n]);
                        else {
                            var a, o = m(e);
                            try {
                                for (o.s(); !(a = o.n()).done;) t(a.value)
                            } catch (e) {
                                o.e(e)
                            } finally {
                                o.f()
                            }
                        }
                    }

                    function ae(e, t) {
                        re(t, (function(t) {
                            return e.push(t)
                        }))
                    }

                    function oe(e) {
                        var t, n = !1,
                            r = null;
                        return Object.assign((function() {
                            for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++) o[i] = arguments[i];
                            t = o, r ? n = !0 : (e.apply(void 0, v(t)), r = requestAnimationFrame((function() {
                                r = null, n && (e.apply(void 0, v(t)), n = !1)
                            })))
                        }), {
                            cancel: function() {
                                cancelAnimationFrame(r), n = !1, r = null
                            }
                        })
                    }
                    z.NONE;
                    var ie = new Set;

                    function ue(e, t) {
                        ie.has(e) || (ie.add(e), requestAnimationFrame((function() {
                            ie.delete(e), t()
                        })))
                    }

                    function ce(e) {
                        var t = 0;
                        return e.seconds && (t += 1e3 * e.seconds), e.minutes && (t += 60 * e.minutes * 1e3), e.hours && (t += 60 * e.hours * 60 * 1e3), e.days && (t += 24 * e.days * 60 * 60 * 1e3), t
                    }

                    function se(e) {
                        e && e.parentNode && e.parentNode.removeChild(e)
                    }

                    function le(e, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Function.prototype,
                            r = ce({
                                seconds: 2
                            }),
                            a = ce({
                                seconds: 10
                            }),
                            o = e.previousSibling,
                            i = e.parentNode;
                        if (!i) throw new Error("Unable to watch for node position: parent element not found");
                        if ("prev-sibling" === t && !o) throw new Error("Unable to watch for node position: there is no previous sibling");
                        var u = 0,
                            c = null,
                            s = null,
                            l = oe((function() {
                                if (!s) {
                                    u++;
                                    var d = Date.now();
                                    if (null == c) c = d;
                                    else if (u >= 10) {
                                        if (d - c < a) return void(s = setTimeout((function() {
                                            c = null, u = 0, s = null, l()
                                        }), r));
                                        c = d, u = 1
                                    }
                                    if ("head" === t && o && o.parentNode !== i) h();
                                    else {
                                        if ("prev-sibling" === t) {
                                            if (null == o.parentNode) return void h();
                                            o.parentNode !== i && p(o.parentNode)
                                        }
                                        "head" !== t || i.isConnected || (i = document.head), i.insertBefore(e, o && o.isConnected ? o.nextSibling : i.firstChild), f.takeRecords(), n && n()
                                    }
                                }
                            })),
                            f = new MutationObserver((function() {
                                ("head" === t && (e.parentNode !== i || !e.parentNode.isConnected) || "prev-sibling" === t && e.previousSibling !== o) && l()
                            })),
                            d = function() {
                                f.observe(i, {
                                    childList: !0
                                })
                            },
                            h = function() {
                                clearTimeout(s), f.disconnect(), l.cancel()
                            },
                            p = function(e) {
                                i = e, h(), d()
                            };
                        return d(), {
                            run: d,
                            stop: h,
                            skip: function() {
                                f.takeRecords()
                            }
                        }
                    }

                    function fe(e, t) {
                        if (null != e)
                            for (var n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
                                    acceptNode: function(e) {
                                        return null == e.shadowRoot ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT
                                    }
                                }), r = e.shadowRoot ? n.currentNode : n.nextNode(); null != r; r = n.nextNode()) r.classList.contains("surfingkeys_hints_host") || (t(r), fe(r.shadowRoot, t))
                    }
                    var de = function() {
                            return "complete" === document.readyState || "interactive" === document.readyState
                        },
                        he = new Set;

                    function pe(e) {
                        de() ? e() : he.add(e)
                    }

                    function ve(e) {
                        he.delete(e)
                    }

                    function me() {
                        return "complete" === document.readyState
                    }
                    var ge = new Set;

                    function be(e) {
                        me() ? e() : ge.add(e)
                    }
                    de() || document.addEventListener("readystatechange", (function e() {
                        de() && (he.forEach((function(e) {
                            return e()
                        })), he.clear(), me() && (document.removeEventListener("readystatechange", e), ge.forEach((function(e) {
                            return e()
                        })), ge.clear()))
                    }));
                    var ye, we = 1e3,
                        Se = new Map,
                        ke = new WeakMap;

                    function Ee(e, t) {
                        var n, r, a;
                        if (Se.has(e)) n = Se.get(e), r = ke.get(n);
                        else {
                            var o = !1,
                                i = !1;
                            n = new MutationObserver((function(t) {
                                if (function(e) {
                                        if (e.length > we) return !0;
                                        for (var t = 0, n = 0; n < e.length; n++)
                                            if ((t += e[n].addedNodes.length) > we) return !0;
                                        return !1
                                    }(t)) !o || de() ? r.forEach((function(t) {
                                    return (0, t.onHugeMutations)(e)
                                })) : i || (pe(a = function() {
                                    return r.forEach((function(t) {
                                        return (0, t.onHugeMutations)(e)
                                    }))
                                }), i = !0), o = !0;
                                else {
                                    var n = function(e) {
                                        var t = new Set,
                                            n = new Set,
                                            r = new Set;
                                        e.forEach((function(e) {
                                            re(e.addedNodes, (function(e) {
                                                e instanceof Element && e.isConnected && t.add(e)
                                            })), re(e.removedNodes, (function(e) {
                                                e instanceof Element && (e.isConnected ? (r.add(e), t.delete(e)) : n.add(e))
                                            }))
                                        }));
                                        var a = [],
                                            o = [];
                                        return t.forEach((function(e) {
                                            t.has(e.parentElement) && a.push(e)
                                        })), n.forEach((function(e) {
                                            n.has(e.parentElement) && o.push(e)
                                        })), a.forEach((function(e) {
                                            return t.delete(e)
                                        })), o.forEach((function(e) {
                                            return n.delete(e)
                                        })), {
                                            additions: t,
                                            moves: r,
                                            deletions: n
                                        }
                                    }(t);
                                    r.forEach((function(t) {
                                        return (0, t.onMinorMutations)(e, n)
                                    }))
                                }
                            })), n.observe(e, {
                                childList: !0,
                                subtree: !0
                            }), Se.set(e, n), r = new Set, ke.set(n, r)
                        }
                        return r.add(t), {
                            disconnect: function() {
                                r.delete(t), a && ve(a), 0 === r.size && (n.disconnect(), ke.delete(n), Se.delete(e))
                            }
                        }
                    }

                    function xe(e, t) {
                        for (var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = []; n = e.exec(t);) a.push(n[r]);
                        return a
                    }

                    function Ce(e) {
                        for (var t = e.length, n = 0, r = 0; r < t; r++) n = (n << 5) - n + e.charCodeAt(r) & 4294967295;
                        return n
                    }

                    function _e(e) {
                        return Ae(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, "(", ")", [])
                    }

                    function Ae(e, t, n, r, a) {
                        var o;
                        o = 0 === a.length ? function(t, n) {
                            return e.indexOf(t, n)
                        } : function(t, n) {
                            return Te(e, t, n, a)
                        };
                        for (var i = e.length, u = 0, c = -1, s = t; s < i; s++)
                            if (0 === u) {
                                var l = o(n, s);
                                if (l < 0) break;
                                c = l, u++, s = l
                            } else {
                                var f = o(r, s);
                                if (f < 0) break;
                                var d = o(n, s);
                                if (d < 0 || f <= d) {
                                    if (0 == --u) return {
                                        start: c,
                                        end: f + 1
                                    };
                                    s = f
                                } else u++, s = d
                            } return null
                    }

                    function Te(e, t, n, r) {
                        var a = e.indexOf(t, n),
                            o = r.find((function(e) {
                                return a >= e.start && a < e.end
                            }));
                        return o ? Te(e, t, o.end, r) : a
                    }

                    function Re(e, t, n) {
                        for (var r = [], a = -1, o = 0;
                            (a = Te(e, t, o, n)) >= 0;) r.push(e.substring(o, a).trim()), o = a + 1;
                        return r.push(e.substring(o).trim()), r
                    }
                    var Le = new Map;

                    function Me(e) {
                        return ye || (ye = document.createElement("a")), ye.href = e, ye.href
                    }

                    function Ve(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                            n = "".concat(e).concat(t ? ";".concat(t) : "");
                        if (Le.has(n)) return Le.get(n);
                        if (t) {
                            var r = new URL(e, Me(t));
                            return Le.set(n, r), r
                        }
                        var a = new URL(Me(e));
                        return Le.set(e, a), a
                    }

                    function Oe(e, t) {
                        if (t.match(/^data\\?\:/)) return t;
                        if (/^\/\//.test(t)) return "".concat(location.protocol).concat(t);
                        var n = Ve(e);
                        return Ve(t, n.href).href
                    }

                    function Pe(e, t, n) {
                        re(e, (function(e) {
                            if (Ye(e)) t(e);
                            else if (function(e) {
                                    return !!e && (!Ge.has(e) && (!!$e.has(e) || !!e.href && ($e.add(e), !0)))
                                }(e)) try {
                                Pe(e.styleSheet.cssRules, t, n)
                            } catch (e) {
                                null == n || n()
                            } else if (Xe(e)) {
                                var r = Array.from(e.media),
                                    a = r.some((function(e) {
                                        return e.startsWith("screen") || e.startsWith("all") || e.startsWith("(")
                                    })),
                                    o = r.some((function(e) {
                                        return e.startsWith("print") || e.startsWith("speech")
                                    }));
                                !a && o || Pe(e.cssRules, t, n)
                            } else ! function(e) {
                                return !!e && (!Ge.has(e) && (!!Qe.has(e) || e instanceof CSSSupportsRule && (Qe.add(e), !0)))
                            }(e) ? Je(e) && Pe(e.cssRules, t, n) : CSS.supports(e.conditionText) && Pe(e.cssRules, t, n)
                        }))
                    }
                    var De = ["background", "border", "border-color", "border-bottom", "border-left", "border-right", "border-top", "outline", "outline-color"],
                        Ne = x ? De.map((function(e) {
                            return [e, new RegExp("".concat(e, ":\\s*(.*?)\\s*;"))]
                        })) : null;

                    function Fe(e, t) {
                        re(e, (function(n) {
                            var r = e.getPropertyValue(n).trim();
                            r && t(n, r)
                        }));
                        var n = e.cssText;
                        n.includes("var(") && (x ? Ne.forEach((function(e) {
                            var r = p(e, 2),
                                a = r[0],
                                o = r[1],
                                i = n.match(o);
                            if (i && i[1]) {
                                var u = i[1].trim();
                                t(a, u)
                            }
                        })) : De.forEach((function(n) {
                            var r = e.getPropertyValue(n);
                            r && r.includes("var(") && t(n, r)
                        }))), n.includes("background-color: ;") && !e.getPropertyValue("background") && je("background", e, t), n.includes("border-") && n.includes("-color: ;") && !e.getPropertyValue("border") && je("border", e, t)
                    }

                    function je(e, t, n) {
                        var r = t.parentRule;
                        if (Ye(r)) {
                            var a, o = null === (a = r.parentStyleSheet) || void 0 === a || null === (a = a.ownerNode) || void 0 === a ? void 0 : a.textContent;
                            if (o) {
                                var i = r.selectorText.replaceAll(/[\^$.*+?\(\)\[\]{}|\-\\]/g, "\\$&");
                                i = (i = i.replaceAll(/\s+/g, "\\s*")).replaceAll(/::/g, "::?");
                                var u = new RegExp("".concat(i, "\\s*{[^}]*?").concat(e, ":\\s*([^;}]+)")),
                                    c = o.match(u);
                                c && n(e, c[1])
                            }
                        }
                    }
                    var Ie = /url\((('.*?')|(".*?")|([^\)]*?))\)/g,
                        We = /@import\s*(url\()?(('.+?')|(".+?")|([^\)]*?))\)? ?(screen)?;?/gi;

                    function qe(e) {
                        return e.trim().replace(/[\n\r\\]+/g, "").replace(/^url\((.*)\)$/, "$1").trim().replace(/^"(.*)"$/, "$1").replace(/^'(.*)'$/, "$1").replace(/(?:\\(.))/g, "$1")
                    }

                    function Be(e) {
                        var t = Ve(e);
                        return "".concat(t.origin).concat(t.pathname.replace(/\?.*$/, "").replace(/(\/)([^\/]+)$/i, "$1"))
                    }

                    function Ue(e, t) {
                        return e.replace(Ie, (function(e) {
                            var n = qe(e);
                            try {
                                return "url('".concat(Oe(t, n), "')")
                            } catch (t) {
                                return e
                            }
                        }))
                    }
                    var He = /@font-face\s*{[^}]*}/g,
                        Ge = new WeakSet,
                        $e = new WeakSet,
                        ze = new WeakSet,
                        Qe = new WeakSet,
                        Ke = new WeakSet;

                    function Ye(e) {
                        return !(!e || !Ge.has(e) && (!e.selectorText || (Ge.add(e), 0)))
                    }

                    function Xe(e) {
                        return !(!e || Ge.has(e) || !ze.has(e) && (!e.media || (ze.add(e), 0)))
                    }

                    function Je(e) {
                        return !!e && !Ge.has(e) && (!!Ke.has(e) || e instanceof CSSLayerBlockRule && (Ke.add(e), !0))
                    }

                    function Ze(e) {
                        for (var t, n = [], r = [], a = 0, o = e.length; a < o; a++) {
                            var i = e[a];
                            if (i && " " !== i) {
                                if (tt.has(i)) {
                                    for (var u = tt.get(i); r.length;) {
                                        var c = tt.get(r[0]);
                                        if (!c) break;
                                        if (!u.lessOrEqualThan(c)) break;
                                        n.push(r.shift())
                                    }
                                    r.unshift(i)
                                } else !t || tt.has(t) ? n.push(i) : n[n.length - 1] += i;
                                t = i
                            }
                        }
                        n.push.apply(n, r);
                        for (var s = [], l = 0, f = n.length; l < f; l++) {
                            var d = tt.get(n[l]);
                            if (d) {
                                var h = s.splice(0, 2);
                                s.push(d.exec(h[1], h[0]))
                            } else s.unshift(parseFloat(n[l]))
                        }
                        return s[0]
                    }
                    var et = function() {
                            function e(t, n) {
                                l(this, e), this.precendce = t, this.execMethod = n
                            }
                            return d(e, [{
                                key: "exec",
                                value: function(e, t) {
                                    return this.execMethod(e, t)
                                }
                            }, {
                                key: "lessOrEqualThan",
                                value: function(e) {
                                    return this.precendce <= e.precendce
                                }
                            }]), e
                        }(),
                        tt = new Map([
                            ["+", new et(1, (function(e, t) {
                                return e + t
                            }))],
                            ["-", new et(1, (function(e, t) {
                                return e - t
                            }))],
                            ["*", new et(2, (function(e, t) {
                                return e * t
                            }))],
                            ["/", new et(2, (function(e, t) {
                                return e / t
                            }))]
                        ]),
                        nt = function() {
                            return matchMedia("(prefers-color-scheme: dark)").matches
                        },
                        rt = new Map,
                        at = new Map;

                    function ot(e) {
                        if (e = e.trim(), at.has(e)) return at.get(e);
                        e.includes("calc(") && (e = function(e) {
                            for (var t = 0, n = function(t, n, r) {
                                    e = e.substring(0, t) + r + e.substring(n)
                                }; - 1 !== (t = e.indexOf("calc("));) {
                                var r = _e(e, t);
                                if (!r) break;
                                var a = e.slice(r.start + 1, r.end - 1),
                                    o = a.includes("%");
                                a = a.split("%").join("");
                                var i = Math.round(Ze(a));
                                n(r.start - 4, r.end, i + (o ? "%" : ""))
                            }
                            return e
                        }(e));
                        var t = pt(e);
                        return t && at.set(e, t), t
                    }

                    function it(e) {
                        if (rt.has(e)) return rt.get(e);
                        var t = ot(e);
                        if (!t) return null;
                        var n = ct(t);
                        return rt.set(e, n), n
                    }

                    function ut(e) {
                        var t = e.h,
                            n = e.s,
                            r = e.l,
                            a = e.a,
                            o = void 0 === a ? 1 : a;
                        if (0 === n) {
                            var i = [r, r, r].map((function(e) {
                                    return Math.round(255 * e)
                                })),
                                u = p(i, 3),
                                c = u[0],
                                s = u[1];
                            return {
                                r: c,
                                g: u[2],
                                b: s,
                                a: o
                            }
                        }
                        var l = (1 - Math.abs(2 * r - 1)) * n,
                            f = l * (1 - Math.abs(t / 60 % 2 - 1)),
                            d = r - l / 2,
                            h = p((t < 60 ? [l, f, 0] : t < 120 ? [f, l, 0] : t < 180 ? [0, l, f] : t < 240 ? [0, f, l] : t < 300 ? [f, 0, l] : [l, 0, f]).map((function(e) {
                                return Math.round(255 * (e + d))
                            })), 3);
                        return {
                            r: h[0],
                            g: h[1],
                            b: h[2],
                            a: o
                        }
                    }

                    function ct(e) {
                        var t = e.r,
                            n = e.g,
                            r = e.b,
                            a = e.a,
                            o = void 0 === a ? 1 : a,
                            i = t / 255,
                            u = n / 255,
                            c = r / 255,
                            s = Math.max(i, u, c),
                            l = Math.min(i, u, c),
                            f = s - l,
                            d = (s + l) / 2;
                        if (0 === f) return {
                            h: 0,
                            s: 0,
                            l: d,
                            a: o
                        };
                        var h = 60 * (s === i ? (u - c) / f % 6 : s === u ? (c - i) / f + 2 : (i - u) / f + 4);
                        return h < 0 && (h += 360), {
                            h,
                            s: f / (1 - Math.abs(2 * d - 1)),
                            l: d,
                            a: o
                        }
                    }

                    function st(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                            n = e.toFixed(t);
                        if (0 === t) return n;
                        var r = n.indexOf(".");
                        if (r >= 0) {
                            var a = n.match(/0+$/);
                            if (a) return a.index === r + 1 ? n.substring(0, r) : n.substring(0, a.index)
                        }
                        return n
                    }

                    function lt(e) {
                        var t = e.h,
                            n = e.s,
                            r = e.l,
                            a = e.a;
                        return null != a && a < 1 ? "hsla(".concat(st(t), ", ").concat(st(100 * n), "%, ").concat(st(100 * r), "%, ").concat(st(a, 2), ")") : "hsl(".concat(st(t), ", ").concat(st(100 * n), "%, ").concat(st(100 * r), "%)")
                    }
                    var ft = /^rgba?\([^\(\)]+\)$/,
                        dt = /^hsla?\([^\(\)]+\)$/,
                        ht = /^#[0-9a-f]+$/i;

                    function pt(e) {
                        var t, n, r, a, o, i = e.trim().toLowerCase();
                        if (i.match(ft)) return bt(i);
                        if (i.match(dt)) return t = p(vt(i, St, kt), 4), n = t[0], r = t[1], a = t[2], o = t[3], ut({
                            h: n,
                            s: r,
                            l: a,
                            a: void 0 === o ? 1 : o
                        });
                        if (i.match(ht)) return function(e) {
                            var t = e.substring(1);
                            switch (t.length) {
                                case 3:
                                case 4:
                                    var n = p([0, 1, 2].map((function(e) {
                                        return parseInt("".concat(t[e]).concat(t[e]), 16)
                                    })), 3);
                                    return {
                                        r: n[0], g: n[1], b: n[2], a: 3 === t.length ? 1 : parseInt("".concat(t[3]).concat(t[3]), 16) / 255
                                    };
                                case 6:
                                case 8:
                                    var r = p([0, 2, 4].map((function(e) {
                                        return parseInt(t.substring(e, e + 2), 16)
                                    })), 3);
                                    return {
                                        r: r[0], g: r[1], b: r[2], a: 6 === t.length ? 1 : parseInt(t.substring(6, 8), 16) / 255
                                    }
                            }
                            return null
                        }(i);
                        if (Et.has(i)) return function(e) {
                            var t = Et.get(e);
                            return {
                                r: t >> 16 & 255,
                                g: t >> 8 & 255,
                                b: t >> 0 & 255,
                                a: 1
                            }
                        }(i);
                        if (xt.has(i)) return function(e) {
                            var t = xt.get(e);
                            return {
                                r: t >> 16 & 255,
                                g: t >> 8 & 255,
                                b: t >> 0 & 255,
                                a: 1
                            }
                        }(i);
                        if ("transparent" === e) return {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 0
                        };
                        if ((i.startsWith("color(") || i.startsWith("color-mix(")) && i.endsWith(")")) return function(e) {
                            wt || ((yt = document.createElement("canvas")).width = 1, yt.height = 1, wt = yt.getContext("2d", {
                                willReadFrequently: !0
                            })), wt.fillStyle = e, wt.fillRect(0, 0, 1, 1);
                            var t = wt.getImageData(0, 0, 1, 1).data;
                            return bt("rgba(".concat(t[0], ", ").concat(t[1], ", ").concat(t[2], ", ").concat((t[3] / 255).toFixed(2), ")"))
                        }(i);
                        if (i.startsWith("light-dark(") && i.endsWith(")")) {
                            var u = i.match(/^light-dark\(\s*([a-z]+(\(.*\))?),\s*([a-z]+(\(.*\))?)\s*\)$/);
                            if (u) return pt(nt() ? u[3] : u[1])
                        }
                        return null
                    }

                    function vt(e, t, n) {
                        var r = function(e) {
                                var t = [],
                                    n = 0,
                                    r = !1,
                                    a = e.indexOf("(");
                                e = e.substring(a + 1, e.length - 1);
                                for (var o = 0; o < e.length; o++) {
                                    var i = e[o];
                                    i >= "0" && i <= "9" || "." === i || "+" === i || "-" === i ? r = !0 : !r || " " !== i && "," !== i && "/" !== i ? r || (n = o + 1) : (t.push(e.substring(n, o)), r = !1, n = o + 1)
                                }
                                return r && t.push(e.substring(n, e.length)), t
                            }(e),
                            a = Object.entries(n);
                        return r.map((function(e) {
                            return e.trim()
                        })).map((function(e, n) {
                            var r, o = a.find((function(t) {
                                var n = p(t, 1)[0];
                                return e.endsWith(n)
                            }));
                            return r = o ? parseFloat(e.substring(0, e.length - o[0].length)) / o[1] * t[n] : parseFloat(e), t[n] > 1 ? Math.round(r) : r
                        }))
                    }
                    var mt = [255, 255, 255, 1],
                        gt = {
                            "%": 100
                        };

                    function bt(e) {
                        var t = p(vt(e, mt, gt), 4),
                            n = t[0],
                            r = t[1],
                            a = t[2],
                            o = t[3];
                        return {
                            r: n,
                            g: r,
                            b: a,
                            a: void 0 === o ? 1 : o
                        }
                    }
                    var yt, wt, St = [360, 1, 1, 1],
                        kt = {
                            "%": 100,
                            deg: 360,
                            rad: 2 * Math.PI,
                            turn: 1
                        },
                        Et = new Map(Object.entries({
                            aliceblue: 15792383,
                            antiquewhite: 16444375,
                            aqua: 65535,
                            aquamarine: 8388564,
                            azure: 15794175,
                            beige: 16119260,
                            bisque: 16770244,
                            black: 0,
                            blanchedalmond: 16772045,
                            blue: 255,
                            blueviolet: 9055202,
                            brown: 10824234,
                            burlywood: 14596231,
                            cadetblue: 6266528,
                            chartreuse: 8388352,
                            chocolate: 13789470,
                            coral: 16744272,
                            cornflowerblue: 6591981,
                            cornsilk: 16775388,
                            crimson: 14423100,
                            cyan: 65535,
                            darkblue: 139,
                            darkcyan: 35723,
                            darkgoldenrod: 12092939,
                            darkgray: 11119017,
                            darkgrey: 11119017,
                            darkgreen: 25600,
                            darkkhaki: 12433259,
                            darkmagenta: 9109643,
                            darkolivegreen: 5597999,
                            darkorange: 16747520,
                            darkorchid: 10040012,
                            darkred: 9109504,
                            darksalmon: 15308410,
                            darkseagreen: 9419919,
                            darkslateblue: 4734347,
                            darkslategray: 3100495,
                            darkslategrey: 3100495,
                            darkturquoise: 52945,
                            darkviolet: 9699539,
                            deeppink: 16716947,
                            deepskyblue: 49151,
                            dimgray: 6908265,
                            dimgrey: 6908265,
                            dodgerblue: 2003199,
                            firebrick: 11674146,
                            floralwhite: 16775920,
                            forestgreen: 2263842,
                            fuchsia: 16711935,
                            gainsboro: 14474460,
                            ghostwhite: 16316671,
                            gold: 16766720,
                            goldenrod: 14329120,
                            gray: 8421504,
                            grey: 8421504,
                            green: 32768,
                            greenyellow: 11403055,
                            honeydew: 15794160,
                            hotpink: 16738740,
                            indianred: 13458524,
                            indigo: 4915330,
                            ivory: 16777200,
                            khaki: 15787660,
                            lavender: 15132410,
                            lavenderblush: 16773365,
                            lawngreen: 8190976,
                            lemonchiffon: 16775885,
                            lightblue: 11393254,
                            lightcoral: 15761536,
                            lightcyan: 14745599,
                            lightgoldenrodyellow: 16448210,
                            lightgray: 13882323,
                            lightgrey: 13882323,
                            lightgreen: 9498256,
                            lightpink: 16758465,
                            lightsalmon: 16752762,
                            lightseagreen: 2142890,
                            lightskyblue: 8900346,
                            lightslategray: 7833753,
                            lightslategrey: 7833753,
                            lightsteelblue: 11584734,
                            lightyellow: 16777184,
                            lime: 65280,
                            limegreen: 3329330,
                            linen: 16445670,
                            magenta: 16711935,
                            maroon: 8388608,
                            mediumaquamarine: 6737322,
                            mediumblue: 205,
                            mediumorchid: 12211667,
                            mediumpurple: 9662683,
                            mediumseagreen: 3978097,
                            mediumslateblue: 8087790,
                            mediumspringgreen: 64154,
                            mediumturquoise: 4772300,
                            mediumvioletred: 13047173,
                            midnightblue: 1644912,
                            mintcream: 16121850,
                            mistyrose: 16770273,
                            moccasin: 16770229,
                            navajowhite: 16768685,
                            navy: 128,
                            oldlace: 16643558,
                            olive: 8421376,
                            olivedrab: 7048739,
                            orange: 16753920,
                            orangered: 16729344,
                            orchid: 14315734,
                            palegoldenrod: 15657130,
                            palegreen: 10025880,
                            paleturquoise: 11529966,
                            palevioletred: 14381203,
                            papayawhip: 16773077,
                            peachpuff: 16767673,
                            peru: 13468991,
                            pink: 16761035,
                            plum: 14524637,
                            powderblue: 11591910,
                            purple: 8388736,
                            rebeccapurple: 6697881,
                            red: 16711680,
                            rosybrown: 12357519,
                            royalblue: 4286945,
                            saddlebrown: 9127187,
                            salmon: 16416882,
                            sandybrown: 16032864,
                            seagreen: 3050327,
                            seashell: 16774638,
                            sienna: 10506797,
                            silver: 12632256,
                            skyblue: 8900331,
                            slateblue: 6970061,
                            slategray: 7372944,
                            slategrey: 7372944,
                            snow: 16775930,
                            springgreen: 65407,
                            steelblue: 4620980,
                            tan: 13808780,
                            teal: 32896,
                            thistle: 14204888,
                            tomato: 16737095,
                            turquoise: 4251856,
                            violet: 15631086,
                            wheat: 16113331,
                            white: 16777215,
                            whitesmoke: 16119285,
                            yellow: 16776960,
                            yellowgreen: 10145074
                        })),
                        xt = new Map(Object.entries({
                            ActiveBorder: 3906044,
                            ActiveCaption: 0,
                            AppWorkspace: 11184810,
                            Background: 6513614,
                            ButtonFace: 16777215,
                            ButtonHighlight: 15329769,
                            ButtonShadow: 10461343,
                            ButtonText: 0,
                            CaptionText: 0,
                            GrayText: 8355711,
                            Highlight: 11720703,
                            HighlightText: 0,
                            InactiveBorder: 16777215,
                            InactiveCaption: 16777215,
                            InactiveCaptionText: 0,
                            InfoBackground: 16514245,
                            InfoText: 0,
                            Menu: 16185078,
                            MenuText: 16777215,
                            Scrollbar: 11184810,
                            ThreeDDarkShadow: 0,
                            ThreeDFace: 12632256,
                            ThreeDHighlight: 16777215,
                            ThreeDLightShadow: 16777215,
                            ThreeDShadow: 0,
                            Window: 15527148,
                            WindowFrame: 11184810,
                            WindowText: 0,
                            "-webkit-focus-ring-color": 15046400
                        }).map((function(e) {
                            var t = p(e, 2),
                                n = t[0],
                                r = t[1];
                            return [n.toLowerCase(), r]
                        })));

                    function Ct(e, t, n) {
                        return (.2126 * e + .7152 * t + .0722 * n) / 255
                    }

                    function _t(e, t, n, r, a) {
                        return (e - t) * (a - r) / (n - t) + r
                    }

                    function At(e, t, n) {
                        return Math.min(n, Math.max(t, e))
                    }

                    function Tt(e, t) {
                        for (var n = [], r = 0, a = e.length; r < a; r++) {
                            n[r] = [];
                            for (var o = 0, i = t[0].length; o < i; o++) {
                                for (var u = 0, c = 0, s = e[0].length; c < s; c++) u += e[r][c] * t[c][o];
                                n[r][o] = u
                            }
                        }
                        return n
                    }

                    function Rt(e) {
                        var t = Lt.identity();
                        return 0 !== e.sepia && (t = Tt(t, Lt.sepia(e.sepia / 100))), 0 !== e.grayscale && (t = Tt(t, Lt.grayscale(e.grayscale / 100))), 100 !== e.contrast && (t = Tt(t, Lt.contrast(e.contrast / 100))), 100 !== e.brightness && (t = Tt(t, Lt.brightness(e.brightness / 100))), 1 === e.mode && (t = Tt(t, Lt.invertNHue())), t
                    }
                    var Lt = {
                        identity: function() {
                            return [
                                [1, 0, 0, 0, 0],
                                [0, 1, 0, 0, 0],
                                [0, 0, 1, 0, 0],
                                [0, 0, 0, 1, 0],
                                [0, 0, 0, 0, 1]
                            ]
                        },
                        invertNHue: function() {
                            return [
                                [.333, -.667, -.667, 0, 1],
                                [-.667, .333, -.667, 0, 1],
                                [-.667, -.667, .333, 0, 1],
                                [0, 0, 0, 1, 0],
                                [0, 0, 0, 0, 1]
                            ]
                        },
                        brightness: function(e) {
                            return [
                                [e, 0, 0, 0, 0],
                                [0, e, 0, 0, 0],
                                [0, 0, e, 0, 0],
                                [0, 0, 0, 1, 0],
                                [0, 0, 0, 0, 1]
                            ]
                        },
                        contrast: function(e) {
                            var t = (1 - e) / 2;
                            return [
                                [e, 0, 0, 0, t],
                                [0, e, 0, 0, t],
                                [0, 0, e, 0, t],
                                [0, 0, 0, 1, 0],
                                [0, 0, 0, 0, 1]
                            ]
                        },
                        sepia: function(e) {
                            return [
                                [.393 + .607 * (1 - e), .769 - .769 * (1 - e), .189 - .189 * (1 - e), 0, 0],
                                [.349 - .349 * (1 - e), .686 + .314 * (1 - e), .168 - .168 * (1 - e), 0, 0],
                                [.272 - .272 * (1 - e), .534 - .534 * (1 - e), .131 + .869 * (1 - e), 0, 0],
                                [0, 0, 0, 1, 0],
                                [0, 0, 0, 0, 1]
                            ]
                        },
                        grayscale: function(e) {
                            return [
                                [.2126 + .7874 * (1 - e), .7152 - .7152 * (1 - e), .0722 - .0722 * (1 - e), 0, 0],
                                [.2126 - .2126 * (1 - e), .7152 + .2848 * (1 - e), .0722 - .0722 * (1 - e), 0, 0],
                                [.2126 - .2126 * (1 - e), .7152 - .7152 * (1 - e), .0722 + .9278 * (1 - e), 0, 0],
                                [0, 0, 0, 1, 0],
                                [0, 0, 0, 0, 1]
                            ]
                        }
                    };

                    function Mt(e) {
                        return e[1 === e.mode ? "darkSchemeBackgroundColor" : "lightSchemeBackgroundColor"]
                    }

                    function Vt(e) {
                        return e[1 === e.mode ? "darkSchemeTextColor" : "lightSchemeTextColor"]
                    }
                    var Ot = new Map,
                        Pt = ["r", "g", "b", "a"],
                        Dt = ["mode", "brightness", "contrast", "grayscale", "sepia", "darkSchemeBackgroundColor", "darkSchemeTextColor", "lightSchemeBackgroundColor", "lightSchemeTextColor"];

                    function Nt(e, t, n, r, a) {
                        var o;
                        Ot.has(n) ? o = Ot.get(n) : (o = new Map, Ot.set(n, o));
                        var i = function(e, t) {
                            var n = "";
                            return Pt.forEach((function(t) {
                                n += "".concat(e[t], ";")
                            })), Dt.forEach((function(e) {
                                n += "".concat(t[e], ";")
                            })), n
                        }(e, t);
                        if (o.has(i)) return o.get(i);
                        var u = ut(n(ct(e), null == r ? null : it(r), null == a ? null : it(a))),
                            c = u.r,
                            s = u.g,
                            l = u.b,
                            f = u.a,
                            d = function(e, t) {
                                var n = p(e, 3),
                                    r = Tt(t, [
                                        [n[0] / 255],
                                        [n[1] / 255],
                                        [n[2] / 255],
                                        [1],
                                        [1]
                                    ]);
                                return [0, 1, 2].map((function(e) {
                                    return At(Math.round(255 * r[e][0]), 0, 255)
                                }))
                            }([c, s, l], Rt(t)),
                            h = p(d, 3),
                            v = h[0],
                            m = h[1],
                            g = h[2],
                            b = 1 === f ? function(e) {
                                var t = e.r,
                                    n = e.g,
                                    r = e.b,
                                    a = e.a;
                                return "#".concat((null != a && a < 1 ? [t, n, r, Math.round(255 * a)] : [t, n, r]).map((function(e) {
                                    return "".concat(e < 16 ? "0" : "").concat(e.toString(16))
                                })).join(""))
                            }({
                                r: v,
                                g: m,
                                b: g
                            }) : function(e) {
                                var t = e.r,
                                    n = e.g,
                                    r = e.b,
                                    a = e.a;
                                return null != a && a < 1 ? "rgba(".concat(st(t), ", ").concat(st(n), ", ").concat(st(r), ", ").concat(st(a, 2), ")") : "rgb(".concat(st(t), ", ").concat(st(n), ", ").concat(st(r), ")")
                            }({
                                r: v,
                                g: m,
                                b: g,
                                a: f
                            });
                        return o.set(i, b), b
                    }

                    function Ft(e) {
                        return e
                    }

                    function jt(e, t) {
                        var n = Mt(t);
                        return Nt(e, t, It, Vt(t), n)
                    }

                    function It(e, t, n) {
                        var r = e.h,
                            a = e.s,
                            o = e.l,
                            i = e.a,
                            u = o < .5,
                            c = r,
                            s = o;
                        return (u ? o < .2 || a < .12 : a < .24 || o > .8 && r > 200 && r < 280) && (u ? (c = t.h, s = t.s) : (c = n.h, s = n.s)), {
                            h: c,
                            s,
                            l: _t(o, 0, 1, t.l, n.l),
                            a: i
                        }
                    }
                    var Wt = .4;

                    function qt(e, t) {
                        var n = e.h,
                            r = e.s,
                            a = e.l,
                            o = e.a,
                            i = r < .12 || a > .8 && n > 200 && n < 280;
                        if (a < .5) {
                            var u = _t(a, 0, .5, 0, Wt);
                            return i ? {
                                h: t.h,
                                s: t.s,
                                l: u,
                                a: o
                            } : {
                                h: n,
                                s: r,
                                l: u,
                                a: o
                            }
                        }
                        var c = _t(a, .5, 1, Wt, t.l);
                        if (i) return {
                            h: t.h,
                            s: t.s,
                            l: c,
                            a: o
                        };
                        var s = n;
                        return n > 60 && n < 180 && (s = n > 120 ? _t(n, 120, 180, 135, 180) : _t(n, 60, 120, 60, 105)), s > 40 && s < 80 && (c *= .75), {
                            h: s,
                            s: r,
                            l: c,
                            a: o
                        }
                    }

                    function Bt(e, t) {
                        if (0 === t.mode) return jt(e, t);
                        var n = Mt(t);
                        return Nt(e, c(c({}, t), {}, {
                            mode: 0
                        }), qt, n)
                    }
                    var Ut, Ht = .55;

                    function Gt(e) {
                        return _t(e, 205, 245, 205, 220)
                    }

                    function $t(e, t) {
                        var n = e.h,
                            r = e.s,
                            a = e.l,
                            o = e.a,
                            i = a < .2 || r < .24,
                            u = !i && n > 205 && n < 245;
                        if (a > .5) {
                            var c = _t(a, .5, 1, Ht, t.l);
                            if (i) return {
                                h: t.h,
                                s: t.s,
                                l: c,
                                a: o
                            };
                            var s = n;
                            return u && (s = Gt(n)), {
                                h: s,
                                s: r,
                                l: c,
                                a: o
                            }
                        }
                        if (i) return {
                            h: t.h,
                            s: t.s,
                            l: _t(a, 0, .5, t.l, Ht),
                            a: o
                        };
                        var l, f = n;
                        return u ? (f = Gt(n), l = _t(a, 0, .5, t.l, Math.min(1, Ht + .05))) : l = _t(a, 0, .5, t.l, Ht), {
                            h: f,
                            s: r,
                            l,
                            a: o
                        }
                    }

                    function zt(e, t) {
                        if (0 === t.mode) return jt(e, t);
                        var n = Vt(t);
                        return Nt(e, c(c({}, t), {}, {
                            mode: 0
                        }), $t, n)
                    }

                    function Qt(e, t, n) {
                        var r = e.h,
                            a = e.s,
                            o = e.l,
                            i = e.a,
                            u = r,
                            c = a;
                        return (o < .2 || a < .24) && (o < .5 ? (u = t.h, c = t.s) : (u = n.h, c = n.s)), {
                            h: u,
                            s: c,
                            l: _t(o, 0, 1, .5, .2),
                            a: i
                        }
                    }

                    function Kt(e, t) {
                        if (0 === t.mode) return jt(e, t);
                        var n = Vt(t),
                            r = Mt(t);
                        return Nt(e, c(c({}, t), {}, {
                            mode: 0
                        }), Qt, n, r)
                    }

                    function Yt(e, t) {
                        return Bt(e, t)
                    }

                    function Xt(e) {
                        var t = [];
                        return e.mode === Ut.dark && t.push("invert(100%) hue-rotate(180deg)"), 100 !== e.brightness && t.push("brightness(".concat(e.brightness, "%)")), 100 !== e.contrast && t.push("contrast(".concat(e.contrast, "%)")), 0 !== e.grayscale && t.push("grayscale(".concat(e.grayscale, "%)")), 0 !== e.sepia && t.push("sepia(".concat(e.sepia, "%)")), 0 === t.length ? null : t.join(" ")
                    }

                    function Jt() {
                        if ("randomUUID" in crypto) {
                            var e = crypto.randomUUID();
                            return e.substring(0, 8) + e.substring(9, 13) + e.substring(14, 18) + e.substring(19, 23) + e.substring(24)
                        }
                        return "getRandomValues" in crypto ? Array.from(crypto.getRandomValues(new Uint8Array(16))).map((function(e) {
                            return ((t = e) < 16 ? "0" : "") + t.toString(16);
                            var t
                        })).join("") : Math.floor(Math.random() * Math.pow(2, 55)).toString(36)
                    }! function(e) {
                        e[e.light = 0] = "light", e[e.dark = 1] = "dark"
                    }(Ut || (Ut = {}));
                    var Zt = new Map,
                        en = new Map;

                    function tn(e) {
                        return nn.apply(this, arguments)
                    }

                    function nn() {
                        return (nn = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.abrupt("return", new Promise((function(e, n) {
                                            var r = Jt();
                                            Zt.set(r, e), en.set(r, n), chrome.runtime.sendMessage({
                                                type: i.FETCH,
                                                data: t,
                                                id: r
                                            })
                                        })));
                                    case 1:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    chrome.runtime.onMessage.addListener((function(e) {
                        var t = e.type,
                            n = e.data,
                            r = e.error,
                            o = e.id;
                        if (t === a.FETCH_RESPONSE) {
                            var i = Zt.get(o),
                                u = en.get(o);
                            Zt.delete(o), en.delete(o), r ? u && u(r) : i && i(n)
                        }
                    }));
                    var rn = new(function() {
                        function e() {
                            l(this, e), this.queue = [], this.timerId = null
                        }
                        return d(e, [{
                            key: "addTask",
                            value: function(e) {
                                this.queue.push(e), this.scheduleFrame()
                            }
                        }, {
                            key: "stop",
                            value: function() {
                                null !== this.timerId && (cancelAnimationFrame(this.timerId), this.timerId = null), this.queue = []
                            }
                        }, {
                            key: "scheduleFrame",
                            value: function() {
                                var e = this;
                                this.timerId || (this.timerId = requestAnimationFrame((function() {
                                    e.timerId = null;
                                    for (var t, n = Date.now(); t = e.queue.shift();)
                                        if (t(), Date.now() - n >= 16.666666666666668) {
                                            e.scheduleFrame();
                                            break
                                        }
                                })))
                            }
                        }]), e
                    }());

                    function an(e) {
                        return on.apply(this, arguments)
                    }

                    function on() {
                        return on = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.abrupt("return", new Promise(function() {
                                            var e = S(y().mark((function e(n, r) {
                                                var a, o, i, u, s;
                                                return y().wrap((function(e) {
                                                    for (;;) switch (e.prev = e.next) {
                                                        case 0:
                                                            if (e.prev = 0, !t.startsWith("data:")) {
                                                                e.next = 5;
                                                                break
                                                            }
                                                            e.t0 = t, e.next = 8;
                                                            break;
                                                        case 5:
                                                            return e.next = 7, un(t);
                                                        case 7:
                                                            e.t0 = e.sent;
                                                        case 8:
                                                            if (o = e.t0, null === (a = Ln(o)) || void 0 === a) {
                                                                e.next = 13;
                                                                break
                                                            }
                                                            e.t1 = a, e.next = 16;
                                                            break;
                                                        case 13:
                                                            return e.next = 15, N(t);
                                                        case 15:
                                                            e.t1 = e.sent;
                                                        case 16:
                                                            if (i = e.t1, !o.startsWith("data:image/svg+xml")) {
                                                                e.next = 23;
                                                                break
                                                            }
                                                            return e.next = 20, hn(o);
                                                        case 20:
                                                            u = e.sent, e.next = 37;
                                                            break;
                                                        case 23:
                                                            return e.next = 25, sn(i);
                                                        case 25:
                                                            if (e.t3 = s = e.sent, e.t2 = null !== e.t3, !e.t2) {
                                                                e.next = 29;
                                                                break
                                                            }
                                                            e.t2 = void 0 !== s;
                                                        case 29:
                                                            if (!e.t2) {
                                                                e.next = 33;
                                                                break
                                                            }
                                                            e.t4 = s, e.next = 36;
                                                            break;
                                                        case 33:
                                                            return e.next = 35, hn(o);
                                                        case 35:
                                                            e.t4 = e.sent;
                                                        case 36:
                                                            u = e.t4;
                                                        case 37:
                                                            rn.addTask((function() {
                                                                var e = yn(u);
                                                                n(c({
                                                                    src: t,
                                                                    dataURL: e.isLarge ? "" : o,
                                                                    width: u.width,
                                                                    height: u.height
                                                                }, e))
                                                            })), e.next = 43;
                                                            break;
                                                        case 40:
                                                            e.prev = 40, e.t5 = e.catch(0), r(e.t5);
                                                        case 43:
                                                        case "end":
                                                            return e.stop()
                                                    }
                                                }), e, null, [
                                                    [0, 40]
                                                ])
                                            })));
                                            return function(t, n) {
                                                return e.apply(this, arguments)
                                            }
                                        }()));
                                    case 1:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        }))), on.apply(this, arguments)
                    }

                    function un(e) {
                        return cn.apply(this, arguments)
                    }

                    function cn() {
                        return (cn = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (new URL(t).origin !== location.origin) {
                                            e.next = 5;
                                            break
                                        }
                                        return e.next = 4, P(t);
                                    case 4:
                                    case 7:
                                        return e.abrupt("return", e.sent);
                                    case 5:
                                        return e.next = 7, tn({
                                            url: t,
                                            responseType: "data-url"
                                        });
                                    case 8:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function sn(e) {
                        return ln.apply(this, arguments)
                    }

                    function ln() {
                        return (ln = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.prev = 0, e.next = 3, createImageBitmap(t);
                                    case 3:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                        return e.prev = 6, e.t0 = e.catch(0), "Unable to create image bitmap for type ".concat(t.type, ": ").concat(String(e.t0)), e.abrupt("return", null);
                                    case 10:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [0, 6]
                            ])
                        })))).apply(this, arguments)
                    }
                    var fn = 256,
                        dn = 0;

                    function hn(e) {
                        return pn.apply(this, arguments)
                    }

                    function pn() {
                        return (pn = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.abrupt("return", new Promise((function(e, n) {
                                            var r = new Image;
                                            r.onload = function() {
                                                return e(r)
                                            }, r.onerror = function() {
                                                return n("Unable to load image ".concat(t))
                                            }, ++dn <= fn || me() ? r.src = t : be((function() {
                                                return r.src = t
                                            }))
                                        })));
                                    case 1:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    var vn, mn, gn = 1024,
                        bn = 262144;

                    function yn(e) {
                        var t, n, r, a;
                        if (vn || (t = gn, n = gn, (vn = document.createElement("canvas")).width = t, vn.height = n, (mn = vn.getContext("2d", {
                                willReadFrequently: !0
                            })).imageSmoothingEnabled = !1), e instanceof HTMLImageElement ? (r = e.naturalWidth, a = e.naturalHeight) : (r = e.width, a = e.height), 0 === r || 0 === a) return {
                            isDark: !1,
                            isLight: !1,
                            isTransparent: !1,
                            isLarge: !1,
                            isTooLarge: !1
                        };
                        if (r * a > bn) return {
                            isDark: !1,
                            isLight: !1,
                            isTransparent: !1,
                            isLarge: !0
                        };
                        var o = r * a,
                            i = Math.min(1, Math.sqrt(gn / o)),
                            u = Math.ceil(r * i),
                            c = Math.ceil(a * i);
                        mn.clearRect(0, 0, u, c), mn.drawImage(e, 0, 0, r, a, 0, 0, u, c);
                        var s, l, f, d, h, p, v, m = mn.getImageData(0, 0, u, c).data,
                            g = 0,
                            b = 0,
                            y = 0;
                        for (f = 0; f < c; f++)
                            for (l = 0; l < u; l++) d = m[0 + (s = 4 * (f * u + l))], h = m[s + 1], p = m[s + 2], m[s + 3] / 255 < .05 ? g++ : ((v = Ct(d, h, p)) < .4 && b++, v > .7 && y++);
                        var w = u * c,
                            S = w - g;
                        return {
                            isDark: b / S >= .7,
                            isLight: y / S >= .7,
                            isTransparent: g / w >= .1,
                            isLarge: !1
                        }
                    }
                    var wn = null,
                        Sn = !1,
                        kn = !1,
                        En = [];

                    function xn() {
                        return Cn.apply(this, arguments)
                    }

                    function Cn() {
                        return (Cn = S(y().mark((function e() {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (Sn) {
                                            e.next = 2;
                                            break
                                        }
                                        return e.abrupt("return");
                                    case 2:
                                        if (!kn) {
                                            e.next = 6;
                                            break
                                        }
                                        return e.next = 5, new Promise((function(e) {
                                            return En.push(e)
                                        }));
                                    case 5:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                        return kn = !0, e.next = 9, new Promise((function(e) {
                                            document.addEventListener("__wp_dark_mode__blobURLCheckResponse", (function(t) {
                                                wn = t.detail.blobURLAllowed, e(), En.forEach((function(e) {
                                                    return e()
                                                })), En.splice(0)
                                            }), {
                                                once: !0
                                            }), document.dispatchEvent(new CustomEvent("__wp_dark_mode__blobURLCheckRequest"))
                                        }));
                                    case 9:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    document.addEventListener("__wp_dark_mode__inlineScriptsAllowed", (function() {
                        return Sn = !0
                    }), {
                        once: !0
                    }), document.addEventListener("securitypolicyviolation", (function e(t) {
                        "blob" === t.blockedURI && (wn = !1, document.removeEventListener("securitypolicyviolation", e))
                    }));
                    var _n = new Set;

                    function An(e, t) {
                        var n = e.dataURL,
                            r = e.width,
                            a = e.height;
                        n.startsWith("data:image/svg+xml") && (n = n.replace(/[<>&'"]/g, (function(e) {
                            var t;
                            return null !== (t = Tn[e]) && void 0 !== t ? t : e
                        })));
                        var o = Rt(t).slice(0, 4).map((function(e) {
                                return e.map((function(e) {
                                    return e.toFixed(3)
                                })).join(" ")
                            })).join(" "),
                            i = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="'.concat(r, '" height="').concat(a, '">'), "<defs>", '<filter id="wp-dark-mode-image-filter">', '<feColorMatrix type="matrix" values="'.concat(o, '" />'), "</filter>", "</defs>", '<image width="'.concat(r, '" height="').concat(a, '" filter="url(#wp-dark-mode-image-filter)" xlink:href="').concat(n, '" />'), "</svg>"].join("");
                        if (!wn) return "data:image/svg+xml;base64,".concat(btoa(i));
                        for (var u = new Uint8Array(i.length), c = 0; c < i.length; c++) u[c] = i.charCodeAt(c);
                        var s = new Blob([u], {
                                type: "image/svg+xml"
                            }),
                            l = URL.createObjectURL(s);
                        return _n.add(l), l
                    }
                    var Tn = {
                            "<": "&lt;",
                            ">": "&gt;",
                            "&": "&amp;",
                            "'": "&apos;",
                            '"': "&quot;"
                        },
                        Rn = new Map;

                    function Ln(e) {
                        var t = e.indexOf(":"),
                            n = e.indexOf(";", t + 1),
                            r = e.indexOf(",", n + 1),
                            a = e.substring(n + 1, r).toLocaleLowerCase(),
                            o = e.substring(t + 1, n);
                        if ("base64" !== a || !o) return null;
                        for (var i = atob(e.substring(r + 1)), u = new Uint8Array(i.length), c = 0; c < i.length; c++) u[c] = i.charCodeAt(c);
                        return new Blob([u], {
                            type: o
                        })
                    }

                    function Mn(e) {
                        return Vn.apply(this, arguments)
                    }

                    function Vn() {
                        return (Vn = S(y().mark((function e(t) {
                            var n, r, a, o;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (wn) {
                                            e.next = 2;
                                            break
                                        }
                                        return e.abrupt("return", null);
                                    case 2:
                                        if (n = Ce(t), !(r = Rn.get(n))) {
                                            e.next = 6;
                                            break
                                        }
                                        return e.abrupt("return", r);
                                    case 6:
                                        if (a = Ln(t)) {
                                            e.next = 14;
                                            break
                                        }
                                        return e.next = 10, fetch(t);
                                    case 10:
                                        return o = e.sent, e.next = 13, o.blob();
                                    case 13:
                                        a = e.sent;
                                    case 14:
                                        return r = URL.createObjectURL(a), Rn.set(n, r), e.abrupt("return", r);
                                    case 17:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function On() {
                        rn && rn.stop(), vn = null, mn = null, _n.forEach((function(e) {
                            return URL.revokeObjectURL(e)
                        })), _n.clear(), Rn.forEach((function(e) {
                            return URL.revokeObjectURL(e)
                        })), Rn.clear()
                    }
                    var Pn = 8,
                        Dn = "conic-",
                        Nn = Dn.length,
                        Fn = "radial-",
                        jn = "linear-";

                    function In(e, t) {
                        return Boolean(e && e.getPropertyPriority(t))
                    }

                    function Wn(e, t, n, r, a, o) {
                        var i = null;
                        if (e.startsWith("--")) i = function(e, t, n, r, a, o) {
                            return e.getModifierForVariable({
                                varName: t,
                                sourceValue: n,
                                rule: r,
                                ignoredImgSelectors: a,
                                isCancelled: o
                            })
                        }(r, e, t, n, a, o);
                        else if (t.includes("var(")) i = function(e, t, n) {
                            return e.getModifierForVarDependant(t, n)
                        }(r, e, t);
                        else if ("color-scheme" === e) i = function(e) {
                            return 0 === e.mode ? "dark light" : "dark"
                        };
                        else if ("scrollbar-color" === e) i = function(e) {
                            var t = e.match(/^\s*([a-z]+(\(.*\))?)\s+([a-z]+(\(.*\))?)\s*$/);
                            if (!t) return e;
                            var n = ot(t[1]),
                                r = ot(t[3]);
                            return n && r ? function(e) {
                                return "".concat(zt(n, e), " ").concat(Bt(n, e))
                            } : null
                        }(t);
                        else if (e.includes("color") && "-webkit-print-color-adjust" !== e || "fill" === e || "stroke" === e || "stop-color" === e)
                            if (e.startsWith("border") && "border-color" !== e && "initial" === t) {
                                var u = e.substring(0, e.length - 6),
                                    c = n.style.getPropertyValue(u);
                                c.startsWith("0px") || "none" === c ? (e = u, i = c) : i = t
                            } else i = function(e, t, n) {
                                if ($n.has(t.toLowerCase())) return t;
                                var r = ot(t);
                                return r ? e.includes("background") ? n.style.webkitMaskImage && "none" !== n.style.webkitMaskImage || n.style.webkitMask && !n.style.webkitMask.startsWith("none") || n.style.mask && "none" !== n.style.mask || n.style.getPropertyValue("mask-image") && "none" !== n.style.getPropertyValue("mask-image") ? function(e) {
                                    return zt(r, e)
                                } : function(e) {
                                    return Bt(r, e)
                                } : e.includes("border") || e.includes("outline") ? function(e) {
                                    return Kt(r, e)
                                } : function(e) {
                                    return zt(r, e)
                                } : null
                            }(e, t, n);
                        else "background-image" === e || "list-style-image" === e ? i = Kn(t, n, a, o) : e.includes("shadow") && (i = function(e) {
                            var t = Yn(e);
                            return t ? function(e) {
                                return t(e).result
                            } : null
                        }(t));
                        return i ? {
                            property: e,
                            value: i,
                            important: In(n.style, e),
                            sourceValue: t
                        } : null
                    }

                    function qn() {
                        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                        return t.filter(Boolean).join(", ")
                    }

                    function Bn(e, t, n) {
                        var r = [];
                        t || (r.push("html {"), r.push("    background-color: ".concat(Bt({
                            r: 255,
                            g: 255,
                            b: 255
                        }, e), " !important;")), r.push("}")), M && 1 === e.mode && (r.push("html {"), r.push("    color-scheme: dark !important;"), r.push("}"), r.push("iframe {"), r.push("    color-scheme: initial;"), r.push("}"));
                        var a = qn(t ? "" : "html, body", n ? "input, textarea, select, button, dialog" : "");
                        return a && (r.push("".concat(a, " {")), r.push("    background-color: ".concat(Bt({
                            r: 255,
                            g: 255,
                            b: 255
                        }, e), ";")), r.push("}")), r.push("".concat(qn("html, body", n ? "input, textarea, select, button" : ""), " {")), r.push("    border-color: ".concat(Kt({
                            r: 76,
                            g: 76,
                            b: 76
                        }, e), ";")), r.push("    color: ".concat(zt({
                            r: 0,
                            g: 0,
                            b: 0
                        }, e), ";")), r.push("}"), r.push("a {"), r.push("    color: ".concat(zt({
                            r: 0,
                            g: 64,
                            b: 255
                        }, e), ";")), r.push("}"), r.push("table {"), r.push("    border-color: ".concat(Kt({
                            r: 128,
                            g: 128,
                            b: 128
                        }, e), ";")), r.push("}"), r.push("::placeholder {"), r.push("    color: ".concat(zt({
                            r: 169,
                            g: 169,
                            b: 169
                        }, e), ";")), r.push("}"), r.push("input:-webkit-autofill,"), r.push("textarea:-webkit-autofill,"), r.push("select:-webkit-autofill {"), r.push("    background-color: ".concat(Bt({
                            r: 250,
                            g: 255,
                            b: 189
                        }, e), " !important;")), r.push("    color: ".concat(zt({
                            r: 0,
                            g: 0,
                            b: 0
                        }, e), " !important;")), r.push("}"), e.scrollbarColor && r.push(function(e) {
                            var t, n, r, a, o, i, u = [];
                            if ("auto" === e.scrollbarColor) t = Bt({
                                r: 241,
                                g: 241,
                                b: 241
                            }, e), n = zt({
                                r: 96,
                                g: 96,
                                b: 96
                            }, e), r = Bt({
                                r: 176,
                                g: 176,
                                b: 176
                            }, e), a = Bt({
                                r: 144,
                                g: 144,
                                b: 144
                            }, e), o = Bt({
                                r: 96,
                                g: 96,
                                b: 96
                            }, e), i = Bt({
                                r: 255,
                                g: 255,
                                b: 255
                            }, e);
                            else {
                                var s = ct(ot(e.scrollbarColor)),
                                    l = s.l > .5,
                                    f = function(e) {
                                        return c(c({}, s), {}, {
                                            l: At(s.l + e, 0, 1)
                                        })
                                    },
                                    d = function(e) {
                                        return c(c({}, s), {}, {
                                            l: At(s.l - e, 0, 1)
                                        })
                                    };
                                t = lt(d(.4)), n = lt(l ? d(.4) : f(.4)), r = lt(s), a = lt(f(.1)), o = lt(f(.2)), i = lt(d(.5))
                            }
                            return u.push("::-webkit-scrollbar {"), u.push("    background-color: ".concat(t, ";")), u.push("    color: ".concat(n, ";")), u.push("}"), u.push("::-webkit-scrollbar-thumb {"), u.push("    background-color: ".concat(r, ";")), u.push("}"), u.push("::-webkit-scrollbar-thumb:hover {"), u.push("    background-color: ".concat(a, ";")), u.push("}"), u.push("::-webkit-scrollbar-thumb:active {"), u.push("    background-color: ".concat(o, ";")), u.push("}"), u.push("::-webkit-scrollbar-corner {"), u.push("    background-color: ".concat(i, ";")), u.push("}"), E && (u.push("* {"), u.push("    scrollbar-color: ".concat(r, " ").concat(t, ";")), u.push("}")), u.join("\n")
                        }(e)), e.selectionColor && r.push(function(e) {
                            var t = [],
                                n = Un(e),
                                r = n.backgroundColorSelection,
                                a = n.foregroundColorSelection;
                            return ["::selection", "::-moz-selection"].forEach((function(e) {
                                t.push("".concat(e, " {")), t.push("    background-color: ".concat(r, " !important;")), t.push("    color: ".concat(a, " !important;")), t.push("}")
                            })), t.join("\n")
                        }(e)), r.join("\n")
                    }

                    function Un(e) {
                        var t, n;
                        if ("auto" === e.selectionColor) t = Bt({
                            r: 0,
                            g: 96,
                            b: 212
                        }, c(c({}, e), {}, {
                            grayscale: 0
                        })), n = zt({
                            r: 255,
                            g: 255,
                            b: 255
                        }, c(c({}, e), {}, {
                            grayscale: 0
                        }));
                        else {
                            var r = ct(ot(e.selectionColor));
                            t = e.selectionColor, n = r.l < .5 ? "#FFF" : "#000"
                        }
                        return {
                            backgroundColorSelection: t,
                            foregroundColorSelection: n
                        }
                    }

                    function Hn(e, t) {
                        return Gn(e, {
                            strict: t.strict
                        })
                    }

                    function Gn(e, t) {
                        var n = t.strict,
                            r = [];
                        return r.push("html, body, ".concat(n ? "body :not(iframe)" : "body > :not(iframe)", " {")), r.push("    background-color: ".concat(Bt({
                            r: 255,
                            g: 255,
                            b: 255
                        }, e), " !important;")), r.push("    border-color: ".concat(Kt({
                            r: 64,
                            g: 64,
                            b: 64
                        }, e), " !important;")), r.push("    color: ".concat(zt({
                            r: 0,
                            g: 0,
                            b: 0
                        }, e), " !important;")), r.push("}"), r.push('div[style*="background-color: rgb(135, 135, 135)"] {'), r.push("    background-color: #878787 !important;"), r.push("}"), r.join("\n")
                    }
                    var $n = new Set(["inherit", "transparent", "initial", "currentcolor", "none", "unset", "auto"]),
                        zn = new Map,
                        Qn = new Map;

                    function Kn(e, t, n, r) {
                        try {
                            var a = function(e) {
                                    for (var t = [], n = 0, r = Dn.length, a = function() {
                                            var a;
                                            if ([jn, Fn, Dn].find((function(t) {
                                                    if (n - t.length >= 0 && e.substring(n - t.length, n) === t) return "repeating" === e.slice(n - t.length - 10, n - t.length - 1) ? (a = "repeating-".concat(t, "gradient"), !0) : "-webkit" === e.slice(n - t.length - 8, n - t.length - 1) ? (a = "-webkit-".concat(t, "gradient"), !0) : (a = "".concat(t, "gradient"), !0)
                                                })), !a) return 1;
                                            var o = _e(e, n + Pn),
                                                i = o.start,
                                                u = o.end,
                                                c = e.substring(i + 1, u - 1);
                                            r = u + 1 + Nn, t.push({
                                                typeGradient: a,
                                                match: c,
                                                offset: a.length + 2,
                                                index: n - a.length + Pn,
                                                hasComma: !0
                                            })
                                        }; - 1 !== (n = e.indexOf("gradient", r)) && !a(););
                                    return t.length && (t[t.length - 1].hasComma = !1), t
                                }(e),
                                o = xe(Ie, e);
                            if (0 === o.length && 0 === a.length) return e;
                            var i = a.map((function(e) {
                                    return c({
                                        type: "gradient"
                                    }, e)
                                })).concat(function(t) {
                                    var n = 0;
                                    return t.map((function(t) {
                                        var r = e.indexOf(t, n);
                                        return n = r + t.length, {
                                            match: t,
                                            index: r
                                        }
                                    }))
                                }(o).map((function(e) {
                                    return c({
                                        type: "url",
                                        offset: 0
                                    }, e)
                                }))).sort((function(e, t) {
                                    return e.index > t.index ? 1 : -1
                                })),
                                u = function(e, t) {
                                    var n, r = e.isDark,
                                        a = e.isLight,
                                        o = e.isTransparent,
                                        i = e.isLarge,
                                        u = e.width,
                                        s = e.src.startsWith("data:") ? "data:" : e.src;
                                    if (i) "Not modifying too large image ".concat(s), n = null;
                                    else if (r && o && 1 === t.mode && u > 2) {
                                        "Inverting dark image ".concat(s);
                                        var l = An(e, c(c({}, t), {}, {
                                            sepia: At(t.sepia + 10, 0, 100)
                                        }));
                                        n = 'url("'.concat(l, '")')
                                    } else if (a && !o && 1 === t.mode) {
                                        "Dimming light image ".concat(s);
                                        var f = An(e, t);
                                        n = 'url("'.concat(f, '")')
                                    } else if (0 === t.mode && a) {
                                        "Applying filter to image ".concat(s);
                                        var d = An(e, c(c({}, t), {}, {
                                            brightness: At(t.brightness - 10, 5, 200),
                                            sepia: At(t.sepia + 10, 0, 100)
                                        }));
                                        n = 'url("'.concat(d, '")')
                                    } else "Not modifying the image ".concat(s), n = null;
                                    return n
                                },
                                s = [],
                                l = 0,
                                f = !1;
                            return i.forEach((function(a, o) {
                                    var c = a.type,
                                        d = a.match,
                                        h = a.index,
                                        p = a.typeGradient,
                                        v = a.hasComma,
                                        m = a.offset,
                                        g = h,
                                        b = l,
                                        w = g + d.length + m;
                                    l = w, b !== g && (f ? s.push((function() {
                                        var t = e.substring(b, g);
                                        return "," === t[0] && (t = t.substring(1)), t
                                    })) : s.push((function() {
                                        return e.substring(b, g)
                                    }))), f = v || !1, "url" === c ? s.push(function(e) {
                                        var a;
                                        if (function(e, t) {
                                                if (!e || 0 === t.length) return !1;
                                                if (t.some((function(e) {
                                                        return "*" === e
                                                    }))) return !0;
                                                for (var n, r = e.split(/,\s*/g), a = function() {
                                                        var e = t[o];
                                                        if (r.some((function(t) {
                                                                return t === e
                                                            }))) return {
                                                            v: !0
                                                        }
                                                    }, o = 0; o < t.length; o++)
                                                    if (n = a()) return n.v;
                                                return !1
                                            }(t.selectorText, n)) return null;
                                        var o = qe(e),
                                            i = 0 === o.length,
                                            c = t.parentStyleSheet,
                                            s = c && c.href ? Be(c.href) : (null == c || null === (a = c.ownerNode) || void 0 === a ? void 0 : a.baseURI) || location.origin;
                                        return o = Oe(s, o),
                                            function() {
                                                var e = S(y().mark((function e(t) {
                                                    var n, a, c, s;
                                                    return y().wrap((function(e) {
                                                        for (;;) switch (e.prev = e.next) {
                                                            case 0:
                                                                if (!i) {
                                                                    e.next = 2;
                                                                    break
                                                                }
                                                                return e.abrupt("return", "url('')");
                                                            case 2:
                                                                if (n = null, !zn.has(o)) {
                                                                    e.next = 7;
                                                                    break
                                                                }
                                                                n = zn.get(o), e.next = 35;
                                                                break;
                                                            case 7:
                                                                if (e.prev = 7, null != wn || !Sn) {
                                                                    e.next = 11;
                                                                    break
                                                                }
                                                                return e.next = 11, xn();
                                                            case 11:
                                                                if (!Qn.has(o)) {
                                                                    e.next = 20;
                                                                    break
                                                                }
                                                                return a = Qn.get(o), e.next = 15, new Promise((function(e) {
                                                                    return a.push(e)
                                                                }));
                                                            case 15:
                                                                if (n = e.sent) {
                                                                    e.next = 18;
                                                                    break
                                                                }
                                                                return e.abrupt("return", null);
                                                            case 18:
                                                                e.next = 27;
                                                                break;
                                                            case 20:
                                                                return Qn.set(o, []), e.next = 23, an(o);
                                                            case 23:
                                                                n = e.sent, zn.set(o, n), Qn.get(o).forEach((function(e) {
                                                                    return e(n)
                                                                })), Qn.delete(o);
                                                            case 27:
                                                                if (!r()) {
                                                                    e.next = 29;
                                                                    break
                                                                }
                                                                return e.abrupt("return", null);
                                                            case 29:
                                                                e.next = 35;
                                                                break;
                                                            case 31:
                                                                e.prev = 31, e.t0 = e.catch(7), e.t0, Qn.has(o) && (Qn.get(o).forEach((function(e) {
                                                                    return e(null)
                                                                })), Qn.delete(o));
                                                            case 35:
                                                                if (!n) {
                                                                    e.next = 39;
                                                                    break
                                                                }
                                                                if (!(c = u(n, t))) {
                                                                    e.next = 39;
                                                                    break
                                                                }
                                                                return e.abrupt("return", c);
                                                            case 39:
                                                                if (!o.startsWith("data:")) {
                                                                    e.next = 45;
                                                                    break
                                                                }
                                                                return e.next = 42, Mn(o);
                                                            case 42:
                                                                if (!(s = e.sent)) {
                                                                    e.next = 45;
                                                                    break
                                                                }
                                                                return e.abrupt("return", 'url("'.concat(s, '")'));
                                                            case 45:
                                                                return e.abrupt("return", 'url("'.concat(o, '")'));
                                                            case 46:
                                                            case "end":
                                                                return e.stop()
                                                        }
                                                    }), e, null, [
                                                        [7, 31]
                                                    ])
                                                })));
                                                return function(t) {
                                                    return e.apply(this, arguments)
                                                }
                                            }()
                                    }(d)) : "gradient" === c && s.push(function(e) {
                                        var t = e.typeGradient,
                                            n = e.match,
                                            r = e.hasComma,
                                            a = /^(from|color-stop|to)\(([^\(\)]*?,\s*)?(.*?)\)$/,
                                            o = xe(/([^\(\),]+(\([^\(\)]*(\([^\(\)]*\)*[^\(\)]*)?\))?([^\(\), ]|( (?!calc)))*),?/g, n, 1).map((function(e) {
                                                var t = ot(e = e.trim());
                                                if (t) return function(e) {
                                                    return Yt(t, e)
                                                };
                                                var n = e.lastIndexOf(" ");
                                                if (t = ot(e.substring(0, n))) return function(r) {
                                                    return "".concat(Yt(t, r), " ").concat(e.substring(n + 1))
                                                };
                                                var r = e.match(a);
                                                return r && (t = ot(r[3])) ? function(e) {
                                                    return "".concat(r[1], "(").concat(r[2] ? "".concat(r[2], ", ") : "").concat(Yt(t, e), ")")
                                                } : function() {
                                                    return e
                                                }
                                            }));
                                        return function(e) {
                                            return "".concat(t, "(").concat(o.map((function(t) {
                                                return t(e)
                                            })).join(", "), ")").concat(r ? ", " : "")
                                        }
                                    }({
                                        match: d,
                                        index: h,
                                        typeGradient: p,
                                        hasComma: v || !1,
                                        offset: m
                                    })), o === i.length - 1 && s.push((function() {
                                        return e.substring(w)
                                    }))
                                })),
                                function(e) {
                                    var t = s.filter(Boolean).map((function(t) {
                                        return t(e)
                                    }));
                                    if (t.some((function(e) {
                                            return e instanceof Promise
                                        }))) return Promise.all(t).then((function(e) {
                                        return e.filter(Boolean).join("")
                                    }));
                                    var n = t.join("");
                                    return n.endsWith(", initial") ? n.slice(0, -9) : n
                                }
                        } catch (e) {
                            return null
                        }
                    }

                    function Yn(e) {
                        try {
                            var t = 0,
                                n = xe(/(^|\s)(?!calc)([a-z]+\(.+?\)|#[0-9a-f]+|[a-z]+)(.*?(inset|outset)?($|,))/gi, e, 2),
                                r = 0,
                                a = n.map((function(a, o) {
                                    var i = t,
                                        u = e.indexOf(a, t),
                                        c = u + a.length;
                                    t = c;
                                    var s = ot(a);
                                    return s ? function(t) {
                                        return "".concat(e.substring(i, u)).concat(function(e, t) {
                                            return Bt(e, t)
                                        }(s, t)).concat(o === n.length - 1 ? e.substring(c) : "")
                                    } : (r++, function() {
                                        return e.substring(i, c)
                                    })
                                }));
                            return function(e) {
                                var t = a.map((function(t) {
                                    return t(e)
                                })).join("");
                                return {
                                    matchesLength: n.length,
                                    unparseableMatchesLength: r,
                                    result: t
                                }
                            }
                        } catch (e) {
                            return null
                        }
                    }

                    function Xn() {
                        Ot.clear(), zn.clear(), On(), Qn.clear()
                    }
                    var Jn = function() {
                            function e() {
                                l(this, e), this.varTypes = new Map, this.rulesQueue = [], this.inlineStyleQueue = [], this.definedVars = new Set, this.varRefs = new Map, this.unknownColorVars = new Set, this.unknownBgVars = new Set, this.undefinedVars = new Set, this.initialVarTypes = new Map, this.changedTypeVars = new Set, this.typeChangeSubscriptions = new Map, this.unstableVarValues = new Map
                            }
                            return d(e, [{
                                key: "clear",
                                value: function() {
                                    this.varTypes.clear(), this.rulesQueue.splice(0), this.inlineStyleQueue.splice(0), this.definedVars.clear(), this.varRefs.clear(), this.unknownColorVars.clear(), this.unknownBgVars.clear(), this.undefinedVars.clear(), this.initialVarTypes.clear(), this.changedTypeVars.clear(), this.typeChangeSubscriptions.clear(), this.unstableVarValues.clear()
                                }
                            }, {
                                key: "isVarType",
                                value: function(e, t) {
                                    return this.varTypes.has(e) && (this.varTypes.get(e) & t) > 0
                                }
                            }, {
                                key: "addRulesForMatching",
                                value: function(e) {
                                    this.rulesQueue.push(e)
                                }
                            }, {
                                key: "addInlineStyleForMatching",
                                value: function(e) {
                                    this.inlineStyleQueue.push(e)
                                }
                            }, {
                                key: "matchVariablesAndDependents",
                                value: function() {
                                    var e = this;
                                    0 === this.rulesQueue.length && 0 === this.inlineStyleQueue.length || (this.changedTypeVars.clear(), this.initialVarTypes = new Map(this.varTypes), this.collectRootVariables(), this.collectVariablesAndVarDep(), this.collectRootVarDependents(), this.varRefs.forEach((function(t, n) {
                                        t.forEach((function(t) {
                                            e.varTypes.has(n) && e.resolveVariableType(t, e.varTypes.get(n))
                                        }))
                                    })), this.unknownColorVars.forEach((function(t) {
                                        e.unknownBgVars.has(t) ? (e.unknownColorVars.delete(t), e.unknownBgVars.delete(t), e.resolveVariableType(t, 1)) : e.isVarType(t, 7) ? e.unknownColorVars.delete(t) : e.undefinedVars.add(t)
                                    })), this.unknownBgVars.forEach((function(t) {
                                        null != e.findVarRef(t, (function(t) {
                                            return e.unknownColorVars.has(t) || e.isVarType(t, 7)
                                        })) ? e.iterateVarRefs(t, (function(t) {
                                            e.resolveVariableType(t, 1)
                                        })) : e.isVarType(t, 9) ? e.unknownBgVars.delete(t) : e.undefinedVars.add(t)
                                    })), this.changedTypeVars.forEach((function(t) {
                                        e.typeChangeSubscriptions.has(t) && e.typeChangeSubscriptions.get(t).forEach((function(e) {
                                            e()
                                        }))
                                    })), this.changedTypeVars.clear())
                                }
                            }, {
                                key: "getModifierForVariable",
                                value: function(e) {
                                    var t = this;
                                    return function(n) {
                                        var r = e.varName,
                                            a = e.sourceValue,
                                            o = e.rule,
                                            i = e.ignoredImgSelectors,
                                            u = e.isCancelled,
                                            c = function() {
                                                var e = [],
                                                    c = function(o, i, u) {
                                                        if (t.isVarType(r, o)) {
                                                            var c, s = i(r);
                                                            if (sr(a))
                                                                if (lr(a)) {
                                                                    var l = br(a, t.unstableVarValues);
                                                                    l || (l = 1 === o ? "#ffffff" : "#000000"), c = u(l, n)
                                                                } else c = rr(a, (function(e) {
                                                                    return i(e)
                                                                }), (function(e) {
                                                                    return u(e, n)
                                                                }));
                                                            else c = u(a, n);
                                                            e.push({
                                                                property: s,
                                                                value: c
                                                            })
                                                        }
                                                    };
                                                if (c(1, ar, vr), c(2, or, mr), c(4, ir, gr), t.isVarType(r, 8)) {
                                                    var s = ur(r),
                                                        l = a;
                                                    sr(a) && (l = rr(a, (function(e) {
                                                        return ar(e)
                                                    }), (function(e) {
                                                        return vr(e, n)
                                                    })));
                                                    var f = Kn(l, o, i, u);
                                                    l = "function" == typeof f ? f(n) : f, e.push({
                                                        property: s,
                                                        value: l
                                                    })
                                                }
                                                return e
                                            },
                                            s = new Set;
                                        return {
                                            declarations: c(),
                                            onTypeChange: {
                                                addListener: function(e) {
                                                    var n = function() {
                                                        var t = c();
                                                        e(t)
                                                    };
                                                    s.add(n), t.subscribeForVarTypeChange(r, n)
                                                },
                                                removeListeners: function() {
                                                    s.forEach((function(e) {
                                                        t.unsubscribeFromVariableTypeChanges(r, e)
                                                    }))
                                                }
                                            }
                                        }
                                    }
                                }
                            }, {
                                key: "getModifierForVarDependant",
                                value: function(e, t) {
                                    var n = this;
                                    if (t.match(/^\s*(rgb|hsl)a?\(/)) {
                                        var r = e.startsWith("background"),
                                            a = fr(e);
                                        return function(e) {
                                            var o = br(t, n.unstableVarValues);
                                            return o || (o = r ? "#ffffff" : "#000000"), (r ? vr : a ? mr : gr)(o, e)
                                        }
                                    }
                                    return "background-color" === e ? function(e) {
                                        return rr(t, (function(e) {
                                            return ar(e)
                                        }), (function(t) {
                                            return vr(t, e)
                                        }))
                                    } : fr(e) ? function(e) {
                                        return rr(t, (function(e) {
                                            return or(e)
                                        }), (function(t) {
                                            return mr(t, e)
                                        }))
                                    } : "background" === e || "background-image" === e || "box-shadow" === e ? function(r) {
                                        var a = new Set,
                                            o = function() {
                                                var o = rr(t, (function(e) {
                                                    return n.isVarType(e, 1) ? ar(e) : n.isVarType(e, 8) ? ur(e) : (a.add(e), e)
                                                }), (function(e) {
                                                    return vr(e, r)
                                                }));
                                                if ("box-shadow" === e) {
                                                    var i = Yn(o)(r);
                                                    if (i.unparseableMatchesLength !== i.matchesLength) return i.result
                                                }
                                                return o
                                            },
                                            i = o();
                                        return a.size > 0 ? i.match(/^var\(.*?, var\(--wp-dark-mode-bg--.*\)\)$/) ? i : new Promise((function(e) {
                                            var t, r = m(a.values());
                                            try {
                                                var i = function() {
                                                    var r = t.value;
                                                    n.subscribeForVarTypeChange(r, (function t() {
                                                        n.unsubscribeFromVariableTypeChanges(r, t);
                                                        var a = o();
                                                        e(a)
                                                    }))
                                                };
                                                for (r.s(); !(t = r.n()).done;) i()
                                            } catch (e) {
                                                r.e(e)
                                            } finally {
                                                r.f()
                                            }
                                        })) : i
                                    } : e.startsWith("border") || e.startsWith("outline") ? function(e) {
                                        return rr(t, (function(e) {
                                            return ir(e)
                                        }), (function(t) {
                                            return gr(t, e)
                                        }))
                                    } : null
                                }
                            }, {
                                key: "subscribeForVarTypeChange",
                                value: function(e, t) {
                                    this.typeChangeSubscriptions.has(e) || this.typeChangeSubscriptions.set(e, new Set);
                                    var n = this.typeChangeSubscriptions.get(e);
                                    n.has(t) || n.add(t)
                                }
                            }, {
                                key: "unsubscribeFromVariableTypeChanges",
                                value: function(e, t) {
                                    this.typeChangeSubscriptions.has(e) && this.typeChangeSubscriptions.get(e).delete(t)
                                }
                            }, {
                                key: "collectVariablesAndVarDep",
                                value: function() {
                                    var e = this;
                                    this.rulesQueue.forEach((function(t) {
                                        Pe(t, (function(t) {
                                            t.style && e.collectVarsFromCSSDeclarations(t.style)
                                        }))
                                    })), this.inlineStyleQueue.forEach((function(t) {
                                        e.collectVarsFromCSSDeclarations(t)
                                    })), this.rulesQueue.splice(0), this.inlineStyleQueue.splice(0)
                                }
                            }, {
                                key: "collectVarsFromCSSDeclarations",
                                value: function(e) {
                                    var t = this;
                                    Fe(e, (function(e, n) {
                                        cr(e) && t.inspectVariable(e, n), sr(n) && t.inspectVarDependant(e, n)
                                    }))
                                }
                            }, {
                                key: "shouldProcessRootVariables",
                                value: function() {
                                    var e;
                                    return this.rulesQueue.length > 0 && (null === (e = document.documentElement.getAttribute("style")) || void 0 === e ? void 0 : e.includes("--"))
                                }
                            }, {
                                key: "collectRootVariables",
                                value: function() {
                                    var e = this;
                                    this.shouldProcessRootVariables() && Fe(document.documentElement.style, (function(t, n) {
                                        cr(t) && e.inspectVariable(t, n)
                                    }))
                                }
                            }, {
                                key: "inspectVariable",
                                value: function(e, t) {
                                    this.unstableVarValues.set(e, t), sr(t) && lr(t) && (this.unknownColorVars.add(e), this.definedVars.add(e)), this.definedVars.has(e) || (this.definedVars.add(e), Boolean(t.match(dr) || t.match(hr) || ot(t)) ? this.unknownColorVars.add(e) : (t.includes("url(") || t.includes("linear-gradient(") || t.includes("radial-gradient(")) && this.resolveVariableType(e, 8))
                                }
                            }, {
                                key: "resolveVariableType",
                                value: function(e, t) {
                                    var n = this.initialVarTypes.get(e) || 0,
                                        r = (this.varTypes.get(e) || 0) | t;
                                    this.varTypes.set(e, r), (r !== n || this.undefinedVars.has(e)) && (this.changedTypeVars.add(e), this.undefinedVars.delete(e)), this.unknownColorVars.delete(e), this.unknownBgVars.delete(e)
                                }
                            }, {
                                key: "collectRootVarDependents",
                                value: function() {
                                    var e = this;
                                    this.shouldProcessRootVariables() && Fe(document.documentElement.style, (function(t, n) {
                                        sr(n) && e.inspectVarDependant(t, n)
                                    }))
                                }
                            }, {
                                key: "inspectVarDependant",
                                value: function(e, t) {
                                    var n = this;
                                    cr(e) ? this.iterateVarDeps(t, (function(t) {
                                        n.varRefs.has(e) || n.varRefs.set(e, new Set), n.varRefs.get(e).add(t)
                                    })) : "background-color" === e || "box-shadow" === e ? this.iterateVarDeps(t, (function(e) {
                                        return n.resolveVariableType(e, 1)
                                    })) : fr(e) ? this.iterateVarDeps(t, (function(e) {
                                        return n.resolveVariableType(e, 2)
                                    })) : e.startsWith("border") || e.startsWith("outline") ? this.iterateVarDeps(t, (function(e) {
                                        return n.resolveVariableType(e, 4)
                                    })) : "background" !== e && "background-image" !== e || this.iterateVarDeps(t, (function(e) {
                                        if (!n.isVarType(e, 9)) {
                                            var t = null != n.findVarRef(e, (function(e) {
                                                return n.unknownColorVars.has(e) || n.isVarType(e, 7)
                                            }));
                                            n.iterateVarRefs(e, (function(e) {
                                                t ? n.resolveVariableType(e, 1) : n.unknownBgVars.add(e)
                                            }))
                                        }
                                    }))
                                }
                            }, {
                                key: "iterateVarDeps",
                                value: function(e, t) {
                                    var n = new Set;
                                    ! function(e, t) {
                                        rr(e, (function(e) {
                                            return t(e), e
                                        }))
                                    }(e, (function(e) {
                                        return n.add(e)
                                    })), n.forEach((function(e) {
                                        return t(e)
                                    }))
                                }
                            }, {
                                key: "findVarRef",
                                value: function(e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Set;
                                    if (n.has(e)) return null;
                                    if (n.add(e), t(e)) return e;
                                    var r = this.varRefs.get(e);
                                    if (!r || 0 === r.size) return null;
                                    var a, o = m(r);
                                    try {
                                        for (o.s(); !(a = o.n()).done;) {
                                            var i = a.value,
                                                u = this.findVarRef(i, t, n);
                                            if (u) return u
                                        }
                                    } catch (e) {
                                        o.e(e)
                                    } finally {
                                        o.f()
                                    }
                                    return null
                                }
                            }, {
                                key: "iterateVarRefs",
                                value: function(e, t) {
                                    this.findVarRef(e, (function(e) {
                                        return t(e), !1
                                    }))
                                }
                            }, {
                                key: "setOnRootVariableChange",
                                value: function(e) {
                                    this.onRootVariableDefined = e
                                }
                            }, {
                                key: "putRootVars",
                                value: function(e, t) {
                                    var n = this,
                                        r = e.sheet;
                                    r.cssRules.length > 0 && r.deleteRule(0);
                                    var a = new Map;
                                    Fe(document.documentElement.style, (function(e, r) {
                                        cr(e) && (n.isVarType(e, 1) && a.set(ar(e), vr(r, t)), n.isVarType(e, 2) && a.set(or(e), mr(r, t)), n.isVarType(e, 4) && a.set(ir(e), gr(r, t)), n.subscribeForVarTypeChange(e, n.onRootVariableDefined))
                                    }));
                                    var o = [];
                                    o.push(":root {");
                                    var i, u = m(a);
                                    try {
                                        for (u.s(); !(i = u.n()).done;) {
                                            var c = p(i.value, 2),
                                                s = c[0],
                                                l = c[1];
                                            o.push("    ".concat(s, ": ").concat(l, ";"))
                                        }
                                    } catch (e) {
                                        u.e(e)
                                    } finally {
                                        u.f()
                                    }
                                    o.push("}");
                                    var f = o.join("\n");
                                    r.insertRule(f)
                                }
                            }]), e
                        }(),
                        Zn = new Jn;

                    function er(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                            n = e.indexOf("var(", t);
                        if (n >= 0) {
                            var r = _e(e, n + 3);
                            if (r) return {
                                start: n,
                                end: r.end
                            }
                        }
                        return null
                    }

                    function tr(e, t) {
                        var n = function(e) {
                                for (var t, n = [], r = 0; t = er(e, r);) {
                                    var a = t,
                                        o = a.start,
                                        i = a.end;
                                    n.push({
                                        start: o,
                                        end: i,
                                        value: e.substring(o, i)
                                    }), r = t.end + 1
                                }
                                return n
                            }(e),
                            r = n.length;
                        if (0 === r) return e;
                        var a = e.length,
                            o = n.map((function(e) {
                                return t(e.value)
                            })),
                            i = [];
                        i.push(e.substring(0, n[0].start));
                        for (var u = 0; u < r; u++) {
                            i.push(o[u]);
                            var c = n[u].end,
                                s = u < r - 1 ? n[u + 1].start : a;
                            i.push(e.substring(c, s))
                        }
                        return i.join("")
                    }

                    function nr(e) {
                        var t, n, r = e.indexOf(",");
                        return r >= 0 ? (t = e.substring(4, r).trim(), n = e.substring(r + 1, e.length - 1).trim()) : (t = e.substring(4, e.length - 1).trim(), n = ""), {
                            name: t,
                            fallback: n
                        }
                    }

                    function rr(e, t, n) {
                        return tr(e, (function(e) {
                            var r, a = nr(e),
                                o = a.name,
                                i = a.fallback,
                                u = t(o);
                            return i ? (r = sr(i) ? rr(i, t, n) : n ? n(i) : i, "var(".concat(u, ", ").concat(r, ")")) : "var(".concat(u, ")")
                        }))
                    }

                    function ar(e) {
                        return "--wp-dark-mode-bg".concat(e)
                    }

                    function or(e) {
                        return "--wp-dark-mode-text".concat(e)
                    }

                    function ir(e) {
                        return "--wp-dark-mode-border".concat(e)
                    }

                    function ur(e) {
                        return "--wp-dark-mode-bgimg".concat(e)
                    }

                    function cr(e) {
                        return e.startsWith("--")
                    }

                    function sr(e) {
                        return e.includes("var(")
                    }

                    function lr(e) {
                        return e.match(/^\s*(rgb|hsl)a?\(/)
                    }

                    function fr(e) {
                        return "color" === e || "caret-color" === e || "-webkit-text-fill-color" === e
                    }
                    var dr = /^(\d{1,3})\s+(\d{1,3})\s+(\d{1,3})$/,
                        hr = /^(\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})$/;

                    function pr(e, t, n) {
                        var r = function(e) {
                                var t, n = null !== (t = e.match(dr)) && void 0 !== t ? t : e.match(hr);
                                return n ? {
                                    isRaw: !0,
                                    color: "rgb(".concat(n[1], ", ").concat(n[2], ", ").concat(n[3], ")")
                                } : {
                                    isRaw: !1,
                                    color: e
                                }
                            }(e),
                            a = r.isRaw,
                            o = r.color,
                            i = ot(o);
                        if (i) {
                            var u = n(i, t);
                            if (a) {
                                var c = ot(u);
                                return c ? "".concat(c.r, ", ").concat(c.g, ", ").concat(c.b) : u
                            }
                            return u
                        }
                        return o
                    }

                    function vr(e, t) {
                        return pr(e, t, Bt)
                    }

                    function mr(e, t) {
                        return pr(e, t, zt)
                    }

                    function gr(e, t) {
                        return pr(e, t, Kt)
                    }

                    function br(e, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Set,
                            r = !1,
                            a = tr(e, (function(e) {
                                var a = nr(e),
                                    o = a.name,
                                    i = a.fallback;
                                if (n.has(o)) return r = !0, null;
                                n.add(o);
                                var u = t.get(o) || i,
                                    c = null;
                                return u && (c = sr(u) ? br(u, t, n) : u), c || (r = !0, null)
                            }));
                        return r ? null : a
                    }
                    var yr = {
                            "background-color": {
                                customProp: "--wp-dark-mode-inline-bgcolor",
                                cssProp: "background-color",
                                dataAttr: "data-wp-dark-mode-inline-bgcolor"
                            },
                            "background-image": {
                                customProp: "--wp-dark-mode-inline-bgimage",
                                cssProp: "background-image",
                                dataAttr: "data-wp-dark-mode-inline-bgimage"
                            },
                            "border-color": {
                                customProp: "--wp-dark-mode-inline-border",
                                cssProp: "border-color",
                                dataAttr: "data-wp-dark-mode-inline-border"
                            },
                            "border-bottom-color": {
                                customProp: "--wp-dark-mode-inline-border-bottom",
                                cssProp: "border-bottom-color",
                                dataAttr: "data-wp-dark-mode-inline-border-bottom"
                            },
                            "border-left-color": {
                                customProp: "--wp-dark-mode-inline-border-left",
                                cssProp: "border-left-color",
                                dataAttr: "data-wp-dark-mode-inline-border-left"
                            },
                            "border-right-color": {
                                customProp: "--wp-dark-mode-inline-border-right",
                                cssProp: "border-right-color",
                                dataAttr: "data-wp-dark-mode-inline-border-right"
                            },
                            "border-top-color": {
                                customProp: "--wp-dark-mode-inline-border-top",
                                cssProp: "border-top-color",
                                dataAttr: "data-wp-dark-mode-inline-border-top"
                            },
                            "box-shadow": {
                                customProp: "--wp-dark-mode-inline-boxshadow",
                                cssProp: "box-shadow",
                                dataAttr: "data-wp-dark-mode-inline-boxshadow"
                            },
                            color: {
                                customProp: "--wp-dark-mode-inline-color",
                                cssProp: "color",
                                dataAttr: "data-wp-dark-mode-inline-color"
                            },
                            fill: {
                                customProp: "--wp-dark-mode-inline-fill",
                                cssProp: "fill",
                                dataAttr: "data-wp-dark-mode-inline-fill"
                            },
                            stroke: {
                                customProp: "--wp-dark-mode-inline-stroke",
                                cssProp: "stroke",
                                dataAttr: "data-wp-dark-mode-inline-stroke"
                            },
                            "outline-color": {
                                customProp: "--wp-dark-mode-inline-outline",
                                cssProp: "outline-color",
                                dataAttr: "data-wp-dark-mode-inline-outline"
                            },
                            "stop-color": {
                                customProp: "--wp-dark-mode-inline-stopcolor",
                                cssProp: "stop-color",
                                dataAttr: "data-wp-dark-mode-inline-stopcolor"
                            }
                        },
                        wr = {
                            background: {
                                customProp: "--wp-dark-mode-inline-bg",
                                cssProp: "background",
                                dataAttr: "data-wp-dark-mode-inline-bg"
                            }
                        },
                        Sr = Object.values(yr),
                        kr = {};
                    Sr.forEach((function(e) {
                        var t = e.cssProp,
                            n = e.customProp;
                        return kr[n] = t
                    }));
                    var Er = ["style", "fill", "stop-color", "stroke", "bgcolor", "color", "background"],
                        xr = Er.map((function(e) {
                            return "[".concat(e, "]")
                        })).join(", ");

                    function Cr() {
                        return Sr.concat(Object.values(wr)).map((function(e) {
                            var t = e.dataAttr,
                                n = e.customProp,
                                r = e.cssProp;
                            return ["[".concat(t, "] {"), "  ".concat(r, ": var(").concat(n, ") !important;"), "}"].join("\n")
                        })).join("\n")
                    }
                    var _r = new Map,
                        Ar = new Map;

                    function Tr(e, t, n) {
                        _r.has(e) && (_r.get(e).disconnect(), Ar.get(e).disconnect());
                        var r = new WeakSet;

                        function a(e) {
                            (function(e) {
                                var t = [];
                                return e instanceof Element && e.matches(xr) && t.push(e), (e instanceof Element || T && e instanceof ShadowRoot || e instanceof Document) && ae(t, e.querySelectorAll(xr)), t
                            })(e).forEach((function(e) {
                                r.has(e) || (r.add(e), t(e))
                            })), fe(e, (function(a) {
                                r.has(e) || (r.add(e), n(a.shadowRoot), Tr(a.shadowRoot, t, n))
                            })), Zn.matchVariablesAndDependents()
                        }
                        var o = Ee(e, {
                            onMinorMutations: function(e, t) {
                                t.additions.forEach((function(e) {
                                    return a(e)
                                }))
                            },
                            onHugeMutations: function() {
                                a(e)
                            }
                        });
                        _r.set(e, o);
                        var i = 0,
                            u = null,
                            c = ce({
                                seconds: 10
                            }),
                            s = ce({
                                seconds: 2
                            }),
                            l = [],
                            f = null,
                            d = oe((function(e) {
                                var n = new Set;
                                e.forEach((function(e) {
                                    var r = e.target;
                                    n.has(r) || Er.includes(e.attributeName) && (n.add(r), t(r))
                                })), Zn.matchVariablesAndDependents()
                            })),
                            h = new MutationObserver((function(e) {
                                if (f) {
                                    var t;
                                    (t = l).push.apply(t, v(e))
                                } else {
                                    i++;
                                    var n = Date.now();
                                    if (null == u) u = n;
                                    else if (i >= 50) {
                                        var r;
                                        if (n - u < c) return f = setTimeout((function() {
                                            u = null, i = 0, f = null;
                                            var e = l;
                                            l = [], d(e)
                                        }), s), void(r = l).push.apply(r, v(e));
                                        u = n, i = 1
                                    }
                                    d(e)
                                }
                            }));
                        h.observe(e, {
                            attributes: !0,
                            attributeFilter: Er.concat(Sr.map((function(e) {
                                return e.dataAttr
                            }))),
                            subtree: !0
                        }), Ar.set(e, h)
                    }
                    var Rr = new WeakMap,
                        Lr = ["brightness", "contrast", "grayscale", "sepia", "mode"];

                    function Mr(e, t) {
                        return Er.map((function(t) {
                            return "".concat(t, '="').concat(e.getAttribute(t), '"')
                        })).concat(Lr.map((function(e) {
                            return "".concat(e, '="').concat(t[e], '"')
                        }))).join(" ")
                    }

                    function Vr(e, t, n, r) {
                        var a;
                    
                        if ( shouldIgnore(e) ) {
                            e.classList.add('wp-dark-mode-ignore');
                            return;
                        }
                        if (Mr(e, t) !== Rr.get(e)) {
                            var o = new Set(Object.keys(yr));
                            if (n.length > 0 && function(e, t) {
                                    for (var n = 0, r = t.length; n < r; n++) {
                                        var a = t[n];
                                        if (e.matches(a)) return !0
                                    }
                                    return !1
                                }(e, n)) o.forEach((function(t) {
                                e.removeAttribute(yr[t].dataAttr)
                            }));
                            else {
                                if (e.hasAttribute("bgcolor")) {
                                    var i = e.getAttribute("bgcolor");
                                    (i.match(/^[0-9a-f]{3}$/i) || i.match(/^[0-9a-f]{6}$/i)) && (i = "#".concat(i)), h("background-color", "background-color", i)
                                }
                                if ((e === document.documentElement || e === document.body) && e.hasAttribute("background")) {
                                    var u, c = Oe(location.href, null !== (u = e.getAttribute("background")) && void 0 !== u ? u : "");
                                    h("background-image", "background-image", 'url("'.concat(c, '")'))
                                }
                                if (e.hasAttribute("color") && "mask-icon" !== e.rel) {
                                    var s = e.getAttribute("color");
                                    (s.match(/^[0-9a-f]{3}$/i) || s.match(/^[0-9a-f]{6}$/i)) && (s = "#".concat(s)), h("color", "color", s)
                                }
                                if (e instanceof SVGElement) {
                                    if (e.hasAttribute("fill")) {
                                        var l = e.getAttribute("fill");
                                        if ("none" !== l)
                                            if (e instanceof SVGTextElement) h("fill", "color", l);
                                            else {
                                                var f = function() {
                                                    var t = e.getBoundingClientRect(),
                                                        n = t.width,
                                                        r = t.height;
                                                    h("fill", n > 32 || r > 32 ? "background-color" : "color", l)
                                                };
                                                me() ? f() : be(f)
                                            }
                                    }
                                    e.hasAttribute("stop-color") && h("stop-color", "background-color", e.getAttribute("stop-color"))
                                }
                                if (e.hasAttribute("stroke")) {
                                    var d = e.getAttribute("stroke");
                                    h("stroke", e instanceof SVGLineElement || e instanceof SVGTextElement ? "border-color" : "color", d)
                                }
                                e.style && Fe(e.style, (function(t, n) {
                                    if ("background-image" === t && n.includes("url")) e !== document.documentElement && e !== document.body || h(t, t, n);
                                    else if (yr.hasOwnProperty(t) || t.startsWith("--") && !kr[t]) h(t, t, n);
                                    else if ("background" === t && n.includes("var(")) h("background", "background", n);
                                    else {
                                        var r = kr[t];
                                        if (r && !e.style.getPropertyValue(r) && !e.hasAttribute(r)) {
                                            if ("background-color" === r && e.hasAttribute("bgcolor")) return;
                                            e.style.setProperty(t, "")
                                        }
                                    }
                                })), e.style && e instanceof SVGTextElement && e.style.fill && h("fill", "color", e.style.getPropertyValue("fill")), null !== (a = e.getAttribute("style")) && void 0 !== a && a.includes("--") && Zn.addInlineStyleForMatching(e.style), re(o, (function(t) {
                                    e.removeAttribute(yr[t].dataAttr)
                                })), Rr.set(e, Mr(e, t))
                            }
                        }

                        function h(n, a, i) {
                            var u = Wn(a, i, {
                                style: e.style
                            }, Zn, r, null);
                            if (u) {
                                var c, s = "function" == typeof u.value ? u.value(t) : u.value;
                                "string" == typeof s ? l(s) : s instanceof Promise ? (c = i, s.then((function(r) {
                                    r && "background" === n && r.startsWith("var(--wp-dark-mode-bg--") && l(r), r && "background-image" === n && (e !== document.documentElement && e !== document.body || r !== c || (r = "none"), l(r)), Rr.set(e, Mr(e, t))
                                }))) : "object" === k(s) && function(t) {
                                    var n = [];

                                    function r(t) {
                                        n.forEach((function(t) {
                                            var n = t.property;
                                            e.style.removeProperty(n)
                                        })), t.forEach((function(t) {
                                            var n = t.property,
                                                r = t.value;
                                            r instanceof Promise || e.style.setProperty(n, r)
                                        })), n = t
                                    }
                                    r(t.declarations), t.onTypeChange.addListener(r)
                                }(s)
                            }

                            function l(t) {
                                var r, a = null !== (r = yr[n]) && void 0 !== r ? r : wr[n],
                                    i = a.customProp,
                                    u = a.dataAttr;
                                e.style.setProperty(i, t), e.hasAttribute(u) || e.setAttribute(u, ""), o.delete(n)
                            }
                        }
                    }
                    var Or = "theme-color",
                        Pr = 'meta[name="'.concat(Or, '"]'),
                        Dr = null,
                        Nr = null;

                    function Fr(e, t) {
                        var n = ot(Dr = Dr || e.content);
                        n && (e.content = Bt(n, t))
                    }
                    var jr = /\/\*[\s\S]*?\*\//g;

                    function Ir(e) {
                        return e.replace(jr, "")
                    }
                    var Wr = ["mode", "brightness", "contrast", "grayscale", "sepia", "darkSchemeBackgroundColor", "darkSchemeTextColor", "lightSchemeBackgroundColor", "lightSchemeTextColor"],
                        qr = function() {
                            var e = [],
                                t = null;

                            function n() {
                                for (var n; n = e.shift();) n();
                                t = null
                            }
                            return {
                                add: function(r) {
                                    e.push(r), t || (t = requestAnimationFrame(n))
                                },
                                cancel: function() {
                                    e.splice(0), cancelAnimationFrame(t), t = null
                                }
                            }
                        }();

                    function Br() {
                        var e = 0,
                            t = new Set,
                            n = new Map,
                            r = new Set,
                            a = null,
                            o = !1,
                            i = !1;
                        return {
                            modifySheet: function(u) {
                                var c = u.sourceCSSRules,
                                    s = u.theme,
                                    l = u.ignoreImageAnalysis,
                                    f = void 0 === l || l,
                                    d = u.force,
                                    h = u.prepareSheet,
                                    p = u.isAsyncCancelled,
                                    g = 0 === n.size,
                                    b = new Set(n.keys()),
                                    y = function(e) {
                                        var t = "";
                                        return Wr.forEach((function(n) {
                                            t += "".concat(n, ":").concat(e[n], ";")
                                        })), t
                                    }(s),
                                    S = y !== a;
                                o && (i = !0);
                                var k = [];
                                if (Pe(c, (function(e) {
                                        var r = function(e) {
                                                var t = e.cssText;
                                                return Xe(e.parentRule) && (t = "".concat(e.parentRule.media.mediaText, " { ").concat(t, " }")), Ce(t)
                                            }(e),
                                            a = !1;
                                        if (b.delete(r), t.has(r) || (t.add(r), a = !0), a) {
                                            if (g = !0, "revert" !== e.style.all) {
                                                var o = [];
                                                e.style && Fe(e.style, (function(t, n) {
                                                    var r = Wn(t, n, e, Zn, f, p);
                                                    r && o.push(r)
                                                }));
                                                var i = null;
                                                if (o.length > 0) {
                                                    var u = e.parentRule;
                                                    i = {
                                                        selector: e.selectorText,
                                                        declarations: o,
                                                        parentRule: u
                                                    }, k.push(i)
                                                }
                                                n.set(r, i)
                                            }
                                        } else k.push(n.get(r))
                                    }), (function() {
                                        o = !0
                                    })), b.forEach((function(e) {
                                        t.delete(e), n.delete(e)
                                    })), a = y, d || g || S) {
                                    e++;
                                    var E = new Map,
                                        x = new Map,
                                        C = 0,
                                        _ = 0,
                                        A = {
                                            rule: null,
                                            rules: [],
                                            isGroup: !0
                                        },
                                        T = new WeakMap;
                                    r.forEach((function(e) {
                                        return e()
                                    })), r.clear(), k.filter((function(e) {
                                        return e
                                    })).forEach((function(t) {
                                        var n = t.selector,
                                            a = t.declarations,
                                            o = M(t.parentRule),
                                            i = {
                                                selector: n,
                                                declarations: [],
                                                isGroup: !1
                                            },
                                            u = i.declarations;

                                        function c(t, n, r, a) {
                                            var o = ++C,
                                                i = {
                                                    property: t,
                                                    value: null,
                                                    important: r,
                                                    asyncKey: o,
                                                    sourceValue: a
                                                };
                                            u.push(i);
                                            var c = e;
                                            n.then((function(t) {
                                                t && !p() && c === e && (i.value = t, qr.add((function() {
                                                    var t, n, r, a, i;
                                                    p() || c !== e || (t = o, n = E.get(t), r = n.rule, a = n.target, i = n.index, a.deleteRule(i), L(a, i, r), E.delete(t))
                                                })))
                                            }))
                                        }

                                        function l(t, n, a, o) {
                                            var i = n.declarations,
                                                s = n.onTypeChange,
                                                l = ++_,
                                                f = e,
                                                d = u.length,
                                                h = [];
                                            if (0 === i.length) {
                                                var m = {
                                                    property: t,
                                                    value: o,
                                                    important: a,
                                                    sourceValue: o,
                                                    varKey: l
                                                };
                                                u.push(m), h = [m]
                                            }
                                            i.forEach((function(e) {
                                                if (e.value instanceof Promise) c(e.property, e.value, a, o);
                                                else {
                                                    var t = {
                                                        property: e.property,
                                                        value: e.value,
                                                        important: a,
                                                        sourceValue: o,
                                                        varKey: l
                                                    };
                                                    u.push(t), h.push(t)
                                                }
                                            })), s.addListener((function(t) {
                                                if (!p() && f === e) {
                                                    var n = t.map((function(e) {
                                                            return {
                                                                property: e.property,
                                                                value: e.value,
                                                                important: a,
                                                                sourceValue: o,
                                                                varKey: l
                                                            }
                                                        })),
                                                        r = u.indexOf(h[0], d);
                                                    u.splice.apply(u, [r, h.length].concat(v(n))), h = n,
                                                        function(e) {
                                                            var t = x.get(e),
                                                                n = t.rule,
                                                                r = t.target,
                                                                a = t.index;
                                                            r.deleteRule(a), L(r, a, n)
                                                        }(l)
                                                }
                                            })), r.add((function() {
                                                return s.removeListeners()
                                            }))
                                        }
                                        o.rules.push(i), a.forEach((function(e) {
                                            var t = e.property,
                                                n = e.value,
                                                r = e.important,
                                                a = e.sourceValue;
                                            if ("function" == typeof n) {
                                                var o = n(s);
                                                o instanceof Promise ? c(t, o, r, a) : t.startsWith("--") ? l(t, o, r, a) : u.push({
                                                    property: t,
                                                    value: o,
                                                    important: r,
                                                    sourceValue: a
                                                })
                                            } else u.push({
                                                property: t,
                                                value: n,
                                                important: r,
                                                sourceValue: a
                                            })
                                        }))
                                    }));
                                    var R = h();
                                    ! function e(t, n, r) {
                                        t.rules.forEach((function(t) {
                                            if (t.isGroup) {
                                                var a = function(e, t) {
                                                    var n = e.rule;
                                                    if (Xe(n)) {
                                                        var r = n.media,
                                                            a = t.cssRules.length;
                                                        return t.insertRule("@media ".concat(r.mediaText, " {}"), a), t.cssRules[a]
                                                    }
                                                    if (Je(n)) {
                                                        var o = n.name,
                                                            i = t.cssRules.length;
                                                        return t.insertRule("@layer ".concat(o, " {}"), i), t.cssRules[i]
                                                    }
                                                    return t
                                                }(t, n);
                                                e(t, a, r)
                                            } else r(t, n)
                                        }))
                                    }(A, R, (function(e, t) {
                                        var n = t.cssRules.length;
                                        e.declarations.forEach((function(r) {
                                            var a = r.asyncKey,
                                                o = r.varKey;
                                            null != a && E.set(a, {
                                                rule: e,
                                                target: t,
                                                index: n
                                            }), null != o && x.set(o, {
                                                rule: e,
                                                target: t,
                                                index: n
                                            })
                                        })), L(t, n, e)
                                    }))
                                }

                                function L(e, t, n) {
                                    var r = n.selector,
                                        a = n.declarations;

                                    // Dark Mode Handle Exclude.
                                    var element = document.querySelector(r);
                                    if (shouldIgnore(element)) {
                                        return;
                                    }

                                    var i = r,
                                        u = w && r.startsWith(":is(") && (r.includes(":is()") || r.includes(":where()") || r.includes(":where(") && r.includes(":-moz")),
                                        c = r.includes("::view-transition-");
                                    (u || c) && (i = ".wp-dark-mode-unsupported-selector");
                                    var l, f = " ".concat(i, " {"),
                                        d = m(a);
                                    try {
                                        for (d.s(); !(l = d.n()).done;) {
                                            var h = l.value,
                                                p = h.property,
                                                v = h.value,
                                                g = h.important;
                                            v && (f += " ".concat(p, ": ").concat(v).concat(g ? " !important" : "", ";"))
                                        }
                                    } catch (e) {
                                        d.e(e)
                                    } finally {
                                        d.f()
                                    }
                                    f += " }", e.insertRule(f, t)
                                }

                                function M(e) {
                                    if (null == e) return A;
                                    if (T.has(e)) return T.get(e);
                                    var t = {
                                        rule: e,
                                        rules: [],
                                        isGroup: !0
                                    };
                                    return T.set(e, t), M(e.parentRule).rules.push(t), t
                                }
                            },
                            shouldRebuildStyle: function() {
                                return o && !i
                            }
                        }
                    }
                    var Ur = !1;

                    function Hr(e, t, n, r) {
                        var a = null,
                            o = !1;

                        function i() {
                            var e;
                            Ur = !0, null === (e = a) || void 0 === e || e.stop(), o || (o = !0, queueMicrotask((function() {
                                o = !1, r() || n()
                            })))
                        }
                        return {
                            start: function() {
                                e.addEventListener("__wp_dark_mode__updateSheet", i), Ur && e.sheet || (a = function(e, t, n, r) {
                                    var a = null,
                                        o = null;

                                    function i() {
                                        var e = t();
                                        return e ? e.length : null
                                    }

                                    function u() {
                                        return i() !== a
                                    }

                                    function c() {
                                        a = i(), s(),
                                            function t() {
                                                var c = r();
                                                !c && u() && (a = i(), n()), c || Ur && e.sheet ? s() : o = requestAnimationFrame(t)
                                            }()
                                    }

                                    function s() {
                                        o && cancelAnimationFrame(o)
                                    }
                                    return {
                                        start: c,
                                        stop: s
                                    }
                                }(e, t, n, r), a.start())
                            },
                            stop: function() {
                                var t;
                                e.removeEventListener("__wp_dark_mode__updateSheet", i), null === (t = a) || void 0 === t || t.stop()
                            }
                        }
                    }
                    document.addEventListener("__wp_dark_mode__inlineScriptsAllowed", (function() {
                        return Ur = !0
                    }), {
                        once: !0
                    });
                    var Gr = 'style, link[rel*="stylesheet" i]:not([disabled])',
                        $r = ["www.onet.pl"];

                    function zr(e) {
                        return (e instanceof HTMLStyleElement || e instanceof SVGStyleElement && !$r.includes(location.hostname) || e instanceof HTMLLinkElement && Boolean(e.rel) && e.rel.toLowerCase().includes("stylesheet") && Boolean(e.href) && !e.disabled && (!E || !e.href.startsWith("moz-extension://")) && ! function(e) {
                            if (!e.href) return !1;
                            try {
                                return "fonts.googleapis.com" === new URL(e.href).hostname
                            } catch (t) {
                                return "Couldn't construct ".concat(e.href, " as URL"), !1
                            }
                        }(e)) && !e.classList.contains("wp-dark-mode") && "print" !== e.media.toLowerCase() && !e.classList.contains("stylus") && !e.id.startsWith("wp-dark-mode-") && !e.classList.contains("wp-dark-mode") && !e.matches(".wp-dark-mode-ignore, .wp-dark-mode-ignore *")
                    }

                    function Qr(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                            n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                        return zr(e) ? t.push(e) : (e instanceof Element || T && e instanceof ShadowRoot || e === document) && (re(e.querySelectorAll(Gr), (function(e) {
                            return Qr(e, t, !1)
                        })), n && fe(e, (function(e) {
                            return Qr(e.shadowRoot, t, !1)
                        }))), t
                    }
                    var Kr = new WeakSet,
                        Yr = new WeakSet,
                        Xr = 0,
                        Jr = new Map;

                    function Zr(e, t) {
                        for (var n = t.update, r = t.loadingStart, a = t.loadingEnd, o = [], i = e;
                            (i = i.nextElementSibling) && i.matches(".wp-dark-mode");) o.push(i);
                        var u = o.find((function(e) {
                                return e.matches(".wp-dark-mode--cors") && !Yr.has(e)
                            })) || null,
                            c = o.find((function(e) {
                                return e.matches(".wp-dark-mode--sync") && !Kr.has(e)
                            })) || null,
                            s = null,
                            l = null,
                            f = !1,
                            d = !0,
                            h = function() {
                                return f
                            },
                            v = Br(),
                            m = new MutationObserver((function(t) {
                                var r;
                                t.some((function(e) {
                                    return "characterData" === e.type
                                })) && b() ? R((null !== (r = e.textContent) && void 0 !== r ? r : "").trim(), location.href).then(n) : n()
                            })),
                            g = {
                                attributes: !0,
                                childList: !0,
                                subtree: !0,
                                characterData: !0
                            };

                        function b() {
                            var t;
                            return e instanceof HTMLStyleElement && Ir(null !== (t = e.textContent) && void 0 !== t ? t : "").trim().match(We)
                        }

                        function w(e, t) {
                            var n, r = !1;
                            if (e) e: for (var a = 0, o = e.length; a < o; a++)
                                if ((n = e[a]).href) {
                                    if (!t) {
                                        r = !0;
                                        break e
                                    }
                                    if (!n.href.startsWith("https://fonts.googleapis.com/") && n.href.startsWith("http") && !n.href.startsWith(location.origin)) {
                                        r = !0;
                                        break e
                                    }
                                } return r
                        }

                        function k() {
                            if (u) return u.sheet.cssRules;
                            if (b()) return null;
                            var t = O();
                            return e instanceof HTMLLinkElement && ! function(e) {
                                if (e.startsWith("data:")) return !0;
                                var t = Ve(e);
                                return t.protocol === location.protocol && t.hostname === location.hostname && t.port === location.port && t.pathname === location.pathname
                            }(e.href) && w(t, !1) || w(t, !0) ? null : t
                        }

                        function E() {
                            u ? (e.nextSibling !== u && e.parentNode.insertBefore(u, e.nextSibling), u.nextSibling !== c && e.parentNode.insertBefore(c, u.nextSibling)) : e.nextSibling !== c && e.parentNode.insertBefore(c, e.nextSibling)
                        }
                        var C = !1,
                            _ = !1,
                            A = ++Xr;

                        function T() {
                            return (T = S(y().mark((function t() {
                                var n, r, a, o, i, c, s, l;
                                return y().wrap((function(t) {
                                    for (;;) switch (t.prev = t.next) {
                                        case 0:
                                            if (!(e instanceof HTMLLinkElement)) {
                                                t.next = 29;
                                                break
                                            }
                                            if (a = V(), o = p(a, 2), i = o[0], c = o[1], !(x && !e.sheet || !x && !i && !c || (d = c, d && d.message && d.message.includes("loading")))) {
                                                t.next = 18;
                                                break
                                            }
                                            return t.prev = 3, "Linkelement ".concat(A, " is not loaded yet and thus will be await for"), t.next = 7, ea(e, A);
                                        case 7:
                                            t.next = 12;
                                            break;
                                        case 9:
                                            t.prev = 9, t.t0 = t.catch(3), _ = !0;
                                        case 12:
                                            if (!f) {
                                                t.next = 14;
                                                break
                                            }
                                            return t.abrupt("return", null);
                                        case 14:
                                            s = V(), l = p(s, 2), i = l[0], c = l[1];
                                        case 18:
                                            if (!i) {
                                                t.next = 21;
                                                break
                                            }
                                            if (w(i, !1)) {
                                                t.next = 21;
                                                break
                                            }
                                            return t.abrupt("return", i);
                                        case 21:
                                            return t.next = 23, na(e.href);
                                        case 23:
                                            if (n = t.sent, r = Be(e.href), !f) {
                                                t.next = 27;
                                                break
                                            }
                                            return t.abrupt("return", null);
                                        case 27:
                                            t.next = 35;
                                            break;
                                        case 29:
                                            if (!b()) {
                                                t.next = 34;
                                                break
                                            }
                                            n = e.textContent.trim(), r = Be(location.href), t.next = 35;
                                            break;
                                        case 34:
                                            return t.abrupt("return", null);
                                        case 35:
                                            return t.next = 37, R(n, r);
                                        case 37:
                                            if (!u) {
                                                t.next = 39;
                                                break
                                            }
                                            return t.abrupt("return", u.sheet.cssRules);
                                        case 39:
                                            return t.abrupt("return", null);
                                        case 40:
                                        case "end":
                                            return t.stop()
                                    }
                                    var d
                                }), t, null, [
                                    [3, 9]
                                ])
                            })))).apply(this, arguments)
                        }

                        function R(e, t) {
                            return L.apply(this, arguments)
                        }

                        function L() {
                            return (L = S(y().mark((function t(n, r) {
                                var a, o, i;
                                return y().wrap((function(t) {
                                    for (;;) switch (t.prev = t.next) {
                                        case 0:
                                            if (!n) {
                                                t.next = 11;
                                                break
                                            }
                                            return t.prev = 1, t.next = 4, aa(n, r);
                                        case 4:
                                            a = t.sent, u ? (null !== (o = null === (i = u.textContent) || void 0 === i ? void 0 : i.length) && void 0 !== o ? o : 0) < a.length && (u.textContent = a) : u = ia(e, a), t.next = 10;
                                            break;
                                        case 8:
                                            t.prev = 8, t.t0 = t.catch(1);
                                        case 10:
                                            u && (s = le(u, "prev-sibling"));
                                        case 11:
                                        case "end":
                                            return t.stop()
                                    }
                                }), t, null, [
                                    [1, 8]
                                ])
                            })))).apply(this, arguments)
                        }
                        var M = !1;

                        function V() {
                            try {
                                return null == e.sheet ? [null, null] : [e.sheet.cssRules, null]
                            } catch (e) {
                                return [null, e]
                            }
                        }

                        function O() {
                            var e = p(V(), 2),
                                t = e[0];
                            return e[1] ? null : t
                        }
                        var P = Hr(e, O, n, h);

                        function D() {
                            m.disconnect(), f = !0, s && s.stop(), l && l.stop(), P.stop()
                        }
                        var N = 0;
                        return {
                            details: function(e) {
                                var t = k();
                                return t ? {
                                    rules: t
                                } : (e.secondRound || C || _ || (C = !0, r(), function() {
                                    return T.apply(this, arguments)
                                }().then((function(e) {
                                    C = !1, a(), e && n()
                                })).catch((function(e) {
                                    C = !1, a()
                                }))), null)
                            },
                            render: function(t) {
                                var r = k();

                                function a() {
                                    return c || ((c = e instanceof SVGStyleElement ? document.createElementNS("http://www.w3.org/2000/svg", "style") : document.createElement("style")).classList.add("wp-dark-mode"), c.classList.add("wp-dark-mode--sync"), c.media = "screen", e.title && (c.title = e.title), Kr.add(c)), l && l.stop(), E(), null == c.sheet && (c.textContent = ""),
                                        function(e) {
                                            if (e)
                                                for (var t = e.cssRules.length - 1; t >= 0; t--) e.deleteRule(t)
                                        }(c.sheet), l ? l.run() : l = le(c, "prev-sibling", (function() {
                                            M = !0, o()
                                        })), c.sheet
                                }

                                function o() {
                                    var e = M;
                                    M = !1, v.modifySheet({
                                        prepareSheet: a,
                                        sourceCSSRules: r,
                                        theme: t,
                                        ignoreImageAnalysis: !0,
                                        force: e,
                                        isAsyncCancelled: h
                                    }), d = 0 === c.sheet.cssRules.length, v.shouldRebuildStyle() && be((function() {
                                        return n()
                                    }))
                                }
                                r && (f = !1, o())
                            },
                            pause: D,
                            destroy: function() {
                                if (D(), se(u), se(c), a(), Jr.has(A)) {
                                    var e = Jr.get(A);
                                    Jr.delete(A), e && e()
                                }
                            },
                            watch: function() {
                                m.observe(e, g), e instanceof HTMLStyleElement && P.start()
                            },
                            restore: function() {
                                c && (++N > 10 || (E(), s && s.skip(), l && l.skip(), d || (M = !0, n())))
                            }
                        }
                    }

                    function ea(e, t) {
                        return ta.apply(this, arguments)
                    }

                    function ta() {
                        return (ta = S(y().mark((function e(t, n) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.abrupt("return", new Promise((function(e, r) {
                                            var a = function() {
                                                    t.removeEventListener("load", o), t.removeEventListener("error", i), Jr.delete(n)
                                                },
                                                o = function() {
                                                    a(), e()
                                                },
                                                i = function() {
                                                    a(), r("Linkelement ".concat(n, " couldn't be loaded. ").concat(t.href))
                                                };
                                            Jr.set(n, (function() {
                                                a(), r()
                                            })), t.addEventListener("load", o, {
                                                passive: !0
                                            }), t.addEventListener("error", i, {
                                                passive: !0
                                            }), t.href || i()
                                        })));
                                    case 1:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function na(e) {
                        return ra.apply(this, arguments)
                    }

                    function ra() {
                        return (ra = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (!t.startsWith("data:")) {
                                            e.next = 6;
                                            break
                                        }
                                        return e.next = 3, fetch(t);
                                    case 3:
                                        return e.next = 5, e.sent.text();
                                    case 5:
                                    case 10:
                                    case 13:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                        if (new URL(t).origin !== location.origin) {
                                            e.next = 11;
                                            break
                                        }
                                        return e.next = 10, W(t, "text/css", location.origin);
                                    case 11:
                                        return e.next = 13, tn({
                                            url: t,
                                            responseType: "text",
                                            mimeType: "text/css",
                                            origin: location.origin
                                        });
                                    case 14:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }

                    function aa(e, t) {
                        return oa.apply(this, arguments)
                    }

                    function oa() {
                        return oa = S(y().mark((function e(t, n) {
                            var r, a, o, i, u, c, s, l, f = arguments;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        r = f.length > 2 && void 0 !== f[2] ? f[2] : new Map, t = Ue(t = (t = Ir(t)).replace(He, ""), n), a = xe(We, t), o = m(a), e.prev = 6, o.s();
                                    case 8:
                                        if ((i = o.n()).done) {
                                            e.next = 33;
                                            break
                                        }
                                        if (u = i.value, c = qe(u.substring(7).trim().replace(/;$/, "").replace(/screen$/, "")), s = Oe(n, c), l = void 0, !r.has(s)) {
                                            e.next = 17;
                                            break
                                        }
                                        l = r.get(s), e.next = 30;
                                        break;
                                    case 17:
                                        return e.prev = 17, e.next = 20, na(s);
                                    case 20:
                                        return l = e.sent, r.set(s, l), e.next = 24, aa(l, Be(s), r);
                                    case 24:
                                        l = e.sent, e.next = 30;
                                        break;
                                    case 27:
                                        e.prev = 27, e.t0 = e.catch(17), l = "";
                                    case 30:
                                        t = t.split(u).join(l);
                                    case 31:
                                        e.next = 8;
                                        break;
                                    case 33:
                                        e.next = 38;
                                        break;
                                    case 35:
                                        e.prev = 35, e.t1 = e.catch(6), o.e(e.t1);
                                    case 38:
                                        return e.prev = 38, o.f(), e.finish(38);
                                    case 41:
                                        return t = t.trim(), e.abrupt("return", t);
                                    case 43:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [6, 35, 38, 41],
                                [17, 27]
                            ])
                        }))), oa.apply(this, arguments)
                    }

                    function ia(e, t) {
                        if (!t) return null;
                        var n = document.createElement("style");
                        return n.classList.add("wp-dark-mode"), n.classList.add("wp-dark-mode--cors"), n.media = "screen", n.textContent = t, e.parentNode.insertBefore(n, e.nextSibling), n.sheet.disabled = !0, Yr.add(n), n
                    }
                    var ua, ca = new Set,
                        sa = new Map;

                    function la(e) {
                        var t = e.tagName.toLowerCase();
                        if (!t.includes("-")) {
                            var n = e.getAttribute("is");
                            if (!n) return;
                            t = n
                        }
                        sa.has(t) || (sa.set(t, new Set), function(e) {
                            return va.apply(this, arguments)
                        }(t).then((function() {
                            if (ua) {
                                var e = sa.get(t);
                                sa.delete(t), ua(Array.from(e))
                            }
                        }))), sa.get(t).add(e)
                    }

                    function fa(e) {
                        L && re(e.querySelectorAll(":not(:defined)"), la)
                    }
                    var da = !1;
                    document.addEventListener("__wp_dark_mode__inlineScriptsAllowed", (function() {
                        da = !0
                    }), {
                        once: !0,
                        passive: !0
                    });
                    var ha = new Map;

                    function pa(e) {
                        da = !0;
                        var t = e.detail.tag;
                        if (ca.add(t), ha.has(t)) {
                            var n = ha.get(t);
                            ha.delete(t), n.forEach((function(e) {
                                return e()
                            }))
                        }
                    }

                    function va() {
                        return (va = S(y().mark((function e(t) {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (!ca.has(t)) {
                                            e.next = 2;
                                            break
                                        }
                                        return e.abrupt("return");
                                    case 2:
                                        return e.abrupt("return", new Promise((function(e) {
                                            window.customElements && "function" == typeof customElements.whenDefined ? customElements.whenDefined(t).then((function() {
                                                return e()
                                            })) : da ? (ha.has(t) ? ha.get(t).push(e) : ha.set(t, [e]), document.dispatchEvent(new CustomEvent("__wp_dark_mode__addUndefinedResolver", {
                                                detail: {
                                                    tag: t
                                                }
                                            }))) : requestAnimationFrame((function n() {
                                                var r = sa.get(t);
                                                r && r.size > 0 && (r.values().next().value.matches(":defined") ? e() : requestAnimationFrame(n))
                                            }))
                                        })));
                                    case 3:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    var ma, ga = [];

                    function ba(e, t, n) {
                        ya();
                        var r = new WeakMap,
                            a = function(e) {
                                return r.has(e) || r.set(e, new Set), r.get(e)
                            };
                        e.forEach((function(e) {
                            for (var t = e; t = t.parentNode;)
                                if (t === document || t.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    a(t).add(e);
                                    break
                                }
                        }));
                        var o = new WeakMap,
                            i = new WeakMap;

                        function u(e) {
                            o.set(e, e.previousElementSibling), i.set(e, e.nextElementSibling)
                        }

                        function c(e, n) {
                            var r = n.createdStyles,
                                c = n.removedStyles,
                                s = n.movedStyles;
                            r.forEach((function(e) {
                                return u(e)
                            })), s.forEach((function(e) {
                                return u(e)
                            })), c.forEach((function(e) {
                                return t = e, o.delete(t), void i.delete(t);
                                var t
                            }));
                            var l = a(e);
                            r.forEach((function(e) {
                                return l.add(e)
                            })), c.forEach((function(e) {
                                return l.delete(e)
                            })), r.size + c.size + s.size > 0 && t({
                                created: Array.from(r),
                                removed: Array.from(c),
                                moved: Array.from(s),
                                updated: []
                            })
                        }

                        function s(e, t) {
                            var n = t.additions,
                                r = t.moves,
                                a = t.deletions,
                                o = new Set,
                                i = new Set,
                                u = new Set;
                            n.forEach((function(e) {
                                return Qr(e).forEach((function(e) {
                                    return o.add(e)
                                }))
                            })), a.forEach((function(e) {
                                return Qr(e).forEach((function(e) {
                                    return i.add(e)
                                }))
                            })), r.forEach((function(e) {
                                return Qr(e).forEach((function(e) {
                                    return u.add(e)
                                }))
                            })), c(e, {
                                createdStyles: o,
                                removedStyles: i,
                                movedStyles: u
                            }), n.forEach((function(e) {
                                p(e), fa(e)
                            })), n.forEach((function(e) {
                                return !(!(t = e).tagName.includes("-") && !t.getAttribute("is")) && la(e);
                                var t
                            }))
                        }

                        function l(e) {
                            var t = new Set(Qr(e)),
                                n = new Set,
                                r = new Set,
                                u = new Set,
                                s = a(e);
                            t.forEach((function(e) {
                                s.has(e) || n.add(e)
                            })), s.forEach((function(e) {
                                t.has(e) || r.add(e)
                            })), t.forEach((function(e) {
                                var t;
                                n.has(e) || r.has(e) || (t = e).previousElementSibling === o.get(t) && t.nextElementSibling === i.get(t) || u.add(e)
                            })), c(e, {
                                createdStyles: n,
                                removedStyles: r,
                                movedStyles: u
                            }), p(e), fa(e)
                        }

                        function f(e) {
                            var n = new Set,
                                r = new Set;
                            e.forEach((function(e) {
                                var t = e.target;
                                t.isConnected && (zr(t) ? n.add(t) : t instanceof HTMLLinkElement && t.disabled && r.add(t))
                            })), n.size + r.size > 0 && t({
                                updated: Array.from(n),
                                created: [],
                                removed: Array.from(r),
                                moved: []
                            })
                        }

                        function d(e) {
                            if (!ma.has(e)) {
                                var t = Ee(e, {
                                        onMinorMutations: s,
                                        onHugeMutations: l
                                    }),
                                    n = new MutationObserver(f);
                                n.observe(e, {
                                    attributeFilter: ["rel", "disabled", "media", "href"],
                                    subtree: !0
                                }), ga.push(t, n), ma.add(e)
                            }
                        }

                        function h(e) {
                            var t = e.shadowRoot;
                            null == t || ma.has(t) || (d(t), n(t))
                        }

                        function p(e) {
                            fe(e, h)
                        }
                        e.forEach(u), d(document), p(document.documentElement), ua = function(e) {
                            var n = [];
                            e.forEach((function(e) {
                                return ae(n, Qr(e.shadowRoot))
                            })), t({
                                created: n,
                                updated: [],
                                removed: [],
                                moved: []
                            }), e.forEach((function(e) {
                                var t = e.shadowRoot;
                                null != t && (h(e), p(t), fa(t))
                            }))
                        }, document.addEventListener("__wp_dark_mode__isDefined", pa), fa(document)
                    }

                    function ya() {
                        ga.forEach((function(e) {
                            return e.disconnect()
                        })), ga.splice(0, ga.length), ma = new WeakSet, ua = null, sa.clear(), document.removeEventListener("__wp_dark_mode__isDefined", pa)
                    }
                    var wa = !1;
                    document.addEventListener("__wp_dark_mode__inlineScriptsAllowed", (function() {
                        return wa = !0
                    }), {
                        once: !0
                    });
                    var Sa = new WeakSet,
                        ka = new WeakMap;

                    function Ea(e) {
                        var t = !1;

                        function n(t, n) {
                            var r = v(e.adoptedStyleSheets),
                                a = r.indexOf(t),
                                o = r.indexOf(n);
                            o >= 0 && r.splice(o, 1), r.splice(a + 1, 0, n), e.adoptedStyleSheets = r
                        }

                        function r() {
                            for (var t = v(e.adoptedStyleSheets), n = t.length - 1; n >= 0; n--) {
                                var r = t[n];
                                Sa.has(r) && (t.splice(n, 1), Sa.delete(r))
                            }
                            e.adoptedStyleSheets.length !== t.length && (e.adoptedStyleSheets = t), u = new WeakSet, c = new WeakSet
                        }
                        var a = [],
                            o = 0;

                        function i() {
                            var t, n = 0;
                            if (t = function(e) {
                                    n += e.cssRules.length
                                }, e.adoptedStyleSheets.forEach((function(e) {
                                    Sa.has(e) || t(e)
                                })), 1 === n) {
                                var r = e.adoptedStyleSheets[0].cssRules[0];
                                return r instanceof CSSStyleRule ? r.style.length : n
                            }
                            return n
                        }
                        var u = new WeakSet,
                            c = new WeakSet,
                            s = !1;

                        function l(t) {
                            s || (s = !0, queueMicrotask((function() {
                                s = !1;
                                var n = e.adoptedStyleSheets.filter((function(e) {
                                    return !Sa.has(e)
                                }));
                                n.forEach((function(e) {
                                    return ka.delete(e)
                                })), t(n)
                            })))
                        }
                        var f = null;

                        function d(e) {
                            f = requestAnimationFrame((function() {
                                wa || (i() !== o && l(e), d(e))
                            }))
                        }

                        function h(t, n) {
                            e.addEventListener(t, n), a.push((function() {
                                return e.removeEventListener(t, n)
                            }))
                        }
                        return {
                            render: function(a) {
                                r();
                                for (var s = function() {
                                        var r = e.adoptedStyleSheets[l];
                                        if (Sa.has(r)) return 0;
                                        u.add(r);
                                        var s = ka.get(r);
                                        if (s) return o = i(), n(r, s), 0;
                                        var f = r.cssRules,
                                            d = new CSSStyleSheet;
                                        ka.set(r, d), Pe(f, (function(e) {
                                            return c.add(e.style)
                                        })), Br().modifySheet({
                                            prepareSheet: function() {
                                                for (var e = d.cssRules.length - 1; e >= 0; e--) d.deleteRule(e);
                                                return d.insertRule("#__wp_dark_mode__adoptedOverride {}"), n(r, d), Sa.add(d), d
                                            },
                                            sourceCSSRules: f,
                                            theme: a,
                                            ignoreImageAnalysis: !0,
                                            force: !1,
                                            isAsyncCancelled: function() {
                                                return t
                                            }
                                        })
                                    }, l = e.adoptedStyleSheets.length - 1; l >= 0; l--) s();
                                o = i()
                            },
                            destroy: function() {
                                a.forEach((function(e) {
                                    return e()
                                })), a.splice(0), t = !0, r(), f && (cancelAnimationFrame(f), f = null)
                            },
                            watch: function(e) {
                                var t = function() {
                                    wa = !0, l(e)
                                };
                                h("__wp_dark_mode__adoptedStyleSheetsChange", t), h("__wp_dark_mode__adoptedStyleSheetChange", t), h("__wp_dark_mode__adoptedStyleDeclarationChange", t), wa || d(e)
                            }
                        }
                    }
                    var xa = function() {
                        function e(t) {
                            l(this, e), this.cssRules = [], this.commands = [], this.onChange = t
                        }
                        return d(e, [{
                            key: "insertRule",
                            value: function(t) {
                                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                                return this.commands.push({
                                    type: "insert",
                                    index: n,
                                    cssText: t
                                }), this.cssRules.splice(n, 0, new e(this.onChange)), this.onChange(), n
                            }
                        }, {
                            key: "deleteRule",
                            value: function(e) {
                                this.commands.push({
                                    type: "delete",
                                    index: e
                                }), this.cssRules.splice(e, 1), this.onChange()
                            }
                        }, {
                            key: "replaceSync",
                            value: function(e) {
                                if (this.commands.splice(0), this.commands.push({
                                        type: "replace",
                                        cssText: e
                                    }), "" !== e) throw new Error("StyleSheetCommandBuilder.replaceSync() is not fully supported");
                                this.cssRules.splice(0), this.onChange()
                            }
                        }, {
                            key: "getDeepCSSCommands",
                            value: function() {
                                var e = [];
                                return this.commands.forEach((function(t) {
                                    e.push({
                                        type: t.type,
                                        cssText: "delete" !== t.type ? t.cssText : "",
                                        path: "replace" === t.type ? [] : [t.index]
                                    })
                                })), this.cssRules.forEach((function(e, t) {
                                    e.getDeepCSSCommands().forEach((function(e) {
                                        return e.path.unshift(t)
                                    }))
                                })), e
                            }
                        }, {
                            key: "clearDeepCSSCommands",
                            value: function() {
                                this.commands.splice(0), this.cssRules.forEach((function(e) {
                                    return e.clearDeepCSSCommands()
                                }))
                            }
                        }]), e
                    }();

                    function Ca(e, t) {
                        document.dispatchEvent(new CustomEvent("__wp_dark_mode__inlineScriptsAllowed"));
                        var n = [];

                        function r(e, t, r) {
                            document.addEventListener(e, t, r), n.push((function() {
                                return document.removeEventListener(e, t)
                            }))
                        }

                        function a(e, t, r) {
                            var a = e.prototype,
                                o = Object.getOwnPropertyDescriptor(a, t),
                                i = c({}, o);
                            Object.keys(r).forEach((function(e) {
                                var t = r[e];
                                i[e] = t(o[e])
                            })), Object.defineProperty(a, t, i), n.push((function() {
                                return Object.defineProperty(a, t, o)
                            }))
                        }

                        function o(e, t, n) {
                            a(e, t, {
                                value: n
                            })
                        }

                        function i(e) {
                            var t;
                            return null == e || null === (t = e.classList) || void 0 === t ? void 0 : t.contains("wp-dark-mode")
                        }

                        function u(e) {
                            return i(e.ownerNode)
                        }
                        r("__wp_dark_mode__cleanUp", (function() {
                            n.forEach((function(e) {
                                return e()
                            })), n.splice(0)
                        }));
                        var s = new CustomEvent("__wp_dark_mode__updateSheet"),
                            l = new CustomEvent("__wp_dark_mode__adoptedStyleSheetChange"),
                            f = new WeakMap,
                            d = new WeakMap;

                        function h(e) {
                            var t = f.get(e);
                            null == t || t.forEach((function(e) {
                                e.isConnected ? e.dispatchEvent(l) : t.delete(e)
                            }))
                        }

                        function p(e) {
                            e.ownerNode && !u(e) && e.ownerNode.dispatchEvent(s), f.has(e) && h(e)
                        }

                        function g(e) {
                            customElements.whenDefined(e).then((function() {
                                document.dispatchEvent(new CustomEvent("__wp_dark_mode__isDefined", {
                                    detail: {
                                        tag: e
                                    }
                                }))
                            }))
                        }

                        function b() {
                            return (b = S(y().mark((function e() {
                                var t, n, r, a, o, i, u;
                                return y().wrap((function(e) {
                                    for (;;) switch (e.prev = e.next) {
                                        case 0:
                                            for (t = '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><rect width="1" height="1" fill="transparent"/></svg>', n = new Uint8Array(114), r = 0; r < 114; r++) n[r] = t.charCodeAt(r);
                                            return a = new Blob([n], {
                                                type: "image/svg+xml"
                                            }), o = URL.createObjectURL(a), e.prev = 5, u = new Image, e.next = 9, new Promise((function(e, t) {
                                                u.onload = function() {
                                                    return e()
                                                }, u.onerror = function() {
                                                    return t()
                                                }, u.src = o
                                            }));
                                        case 9:
                                            i = !0, e.next = 15;
                                            break;
                                        case 12:
                                            e.prev = 12, e.t0 = e.catch(5), i = !1;
                                        case 15:
                                            document.dispatchEvent(new CustomEvent("__wp_dark_mode__blobURLCheckResponse", {
                                                detail: {
                                                    blobURLAllowed: i
                                                }
                                            }));
                                        case 16:
                                        case "end":
                                            return e.stop()
                                    }
                                }), e, null, [
                                    [5, 12]
                                ])
                            })))).apply(this, arguments)
                        }
                        o(CSSStyleSheet, "addRule", (function(e) {
                            return function(t, n, r) {
                                return e.call(this, t, n, r), p(this), -1
                            }
                        })), o(CSSStyleSheet, "insertRule", (function(e) {
                            return function(t, n) {
                                var r = e.call(this, t, n);
                                return p(this), r
                            }
                        })), o(CSSStyleSheet, "deleteRule", (function(e) {
                            return function(t) {
                                e.call(this, t), p(this)
                            }
                        })), o(CSSStyleSheet, "removeRule", (function(e) {
                            return function(t) {
                                e.call(this, t), p(this)
                            }
                        })), o(CSSStyleSheet, "replace", (function(e) {
                            return function(t) {
                                var n, r, a, o = e.call(this, t);
                                return r = o, (a = (n = this).ownerNode) && !u(n) && r && r instanceof Promise && r.then((function() {
                                    return a.dispatchEvent(s)
                                })), f.has(n) && r && r instanceof Promise && r.then((function() {
                                    return h(n)
                                })), o
                            }
                        })), o(CSSStyleSheet, "replaceSync", (function(e) {
                            return function(t) {
                                e.call(this, t), p(this)
                            }
                        })), ("baidu.com" === location.hostname || location.hostname.endsWith(".baidu.com")) && o(Element, "getElementsByTagName", (function(e) {
                            return function(t) {
                                var n = this;
                                if ("style" !== t) return e.call(this, t);
                                var r = function() {
                                        var r = e.call(n, t);
                                        return Object.setPrototypeOf(v(r).filter((function(e) {
                                            return e && !i(e)
                                        })), NodeList.prototype)
                                    },
                                    a = r();
                                return a = new Proxy(a, {
                                    get: function(e, t) {
                                        return r()[Number(t) || t]
                                    }
                                })
                            }
                        })), ["brilliant.org", "www.vy.no"].includes(location.hostname) && a(Node, "childNodes", {
                            get: function(e) {
                                return function() {
                                    var t = e.call(this);
                                    return Object.setPrototypeOf(v(t).filter((function(e) {
                                        return !i(e)
                                    })), NodeList.prototype)
                                }
                            }
                        }), r("__wp_dark_mode__addUndefinedResolver", (function(e) {
                            return g(e.detail.tag)
                        })), t && o(CustomElementRegistry, "define", (function(e) {
                            return function(t, n, r) {
                                g(t), e.call(this, t, n, r)
                            }
                        })), r("__wp_dark_mode__blobURLCheckRequest", (function() {
                            return b.apply(this, arguments)
                        }), {
                            once: !0
                        }), e && a(Document, "styleSheets", {
                            get: function(e) {
                                return function() {
                                    var t = this,
                                        n = function() {
                                            var n = v(e.call(t)).filter((function(e) {
                                                return e.ownerNode && !u(e)
                                            }));
                                            return n.item = function(e) {
                                                return n[e]
                                            }, Object.setPrototypeOf(n, StyleSheetList.prototype)
                                        },
                                        r = n();
                                    return r = new Proxy(r, {
                                        get: function(e, t) {
                                            return n()[t]
                                        }
                                    })
                                }
                            }
                        });
                        var w = new WeakMap,
                            k = new WeakMap,
                            E = new CustomEvent("__wp_dark_mode__adoptedStyleSheetsChange"),
                            x = new WeakSet,
                            C = new WeakMap,
                            _ = function(e) {
                                var t, n, r = C.get(e),
                                    a = (e.adoptedStyleSheets || []).filter((function(e) {
                                        return !((t = e) && t.cssRules && (x.has(t) || t.cssRules.length > 0 && t.cssRules[0].cssText.startsWith("#__wp_dark_mode__adoptedOverride") && (x.add(t), 1)));
                                        var t
                                    }));
                                C.set(e, a), r && (n = a, (t = r).length === n.length && t.every((function(e, t) {
                                    return e === n[t]
                                }))) || (a.forEach((function(t) {
                                    f.has(t) || f.set(t, new Set), f.get(t).add(e);
                                    var n, r = m(t.cssRules);
                                    try {
                                        for (r.s(); !(n = r.n()).done;) {
                                            var a = n.value.style;
                                            a && d.set(a, t)
                                        }
                                    } catch (e) {
                                        r.e(e)
                                    } finally {
                                        r.f()
                                    }
                                })), e.dispatchEvent(E))
                            };
                        [Document, ShadowRoot].forEach((function(e) {
                            a(e, "adoptedStyleSheets", {
                                get: function(e) {
                                    return function() {
                                        return function(e, t) {
                                            if (k.has(t)) return t;
                                            if (w.has(t)) return w.get(t);
                                            var n = new Proxy(t, {
                                                deleteProperty: function(e, t) {
                                                    return delete e[t], !0
                                                },
                                                set: function(t, n, r) {
                                                    return t[n] = r, "length" === n && _(e), !0
                                                }
                                            });
                                            return w.set(t, n), k.set(n, t), n
                                        }(this, e.call(this))
                                    }
                                },
                                set: function(e) {
                                    return function(t) {
                                        k.has(t) && (t = k.get(t)), e.call(this, t), _(this)
                                    }
                                }
                            })
                        }));
                        var A = new CustomEvent("__wp_dark_mode__adoptedStyleDeclarationChange");
                        ["setProperty", "removeProperty"].forEach((function(e) {
                            o(CSSStyleDeclaration, e, (function(e) {
                                return function() {
                                    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                                    var a = e.apply(this, n),
                                        o = d.get(this);
                                    if (o) {
                                        var i = f.get(o);
                                        i && i.forEach((function(e) {
                                            e.dispatchEvent(A)
                                        }))
                                    }
                                    return a
                                }
                            }))
                        }))
                    }
                    var _a = null,
                        Aa = !document.hidden,
                        Ta = {
                            capture: !0,
                            passive: !0
                        };

                    function Ra(e) {
                        var t = Boolean(_a);
                        _a = function() {
                            document.hidden || (La(), e(), Aa = !0)
                        }, t || (document.addEventListener("visibilitychange", _a, Ta), window.addEventListener("pageshow", _a, Ta), window.addEventListener("focus", _a, Ta))
                    }

                    function La() {
                        document.removeEventListener("visibilitychange", _a, Ta), window.removeEventListener("pageshow", _a, Ta), window.removeEventListener("focus", _a, Ta), _a = null
                    }

                    function Ma() {
                        return Aa
                    }
                    var Va = Jt(),
                        Oa = new Map,
                        Pa = [],
                        Da = new Map,
                        Na = new WeakMap,
                        Fa = new WeakMap,
                        ja = null,
                        Ia = null,
                        Wa = null,
                        qa = [],
                        Ba = [];

                    function Ua(e) {
                        var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document.head || document).querySelector(".".concat(e));
                        return t || ((t = document.createElement("style")).classList.add("wp-dark-mode"), t.classList.add(e), t.media = "screen", t.textContent = ""), t
                    }
                    var Ha = new Map;

                    function Ga(e, t) {
                        Ha.has(t) && Ha.get(t).stop(), Ha.set(t, le(e, "head"))
                    }
                    var $a = {};

                    function za() {
                        var e = Ua("wp-dark-mode--fallback", document);
                        e.textContent = Hn(ja, {
                            strict: !0
                        }), document.head.insertBefore(e, document.head.firstChild), Ga(e, "fallback");
                        var t = Ua("wp-dark-mode--user-agent");
                        t.textContent = Bn(ja, Wa, ja.styleSystemControls), document.head.insertBefore(t, e.nextSibling), Ga(t, "user-agent");
                        var n, r, a = Ua("wp-dark-mode--text");
                        ja.useFont || ja.textStroke > 0 ? a.textContent = (n = ja, (r = []).push('*:not(pre, pre *, code, .far, .fa, .glyphicon, [class*="vjs-"],[class*="fa-"], .fab, .fa-github, .fas, .material-icons, .icofont, .typcn, mu, [class*="mu-"], .glyphicon, .icon, .dashicons, .ab-icon, .wp-dark-mode-ignore *, i) {'), n.useFont && n.fontFamily && r.push("  font-family: ".concat(n.fontFamily, " !important;")), n.textStroke > 0 && (r.push("  -webkit-text-stroke: ".concat(n.textStroke, "px !important;")), r.push("  text-stroke: ".concat(n.textStroke, "px !important;"))), r.push("}"), r.join("\n")) : a.textContent = "", document.head.insertBefore(a, e.nextSibling), Ga(a, "text");
                        var o = Ua("wp-dark-mode--invert");
                        Ia && Array.isArray(Ia.invert) && Ia.invert.length > 0 ? o.textContent = ["".concat(Ia.invert.join(", "), " {"), "    filter: ".concat(Xt(c(c({}, ja), {}, {
                            contrast: 0 === ja.mode ? ja.contrast : At(ja.contrast - 10, 0, 100)
                        })), " !important;"), "}"].join("\n") : o.textContent = "", document.head.insertBefore(o, a.nextSibling), Ga(o, "invert");
                        var i = Ua("wp-dark-mode--inline");
                        i.textContent = Cr(), document.head.insertBefore(i, o.nextSibling), Ga(i, "inline");
                        var u = Ua("wp-dark-mode--override");
                        u.textContent = Ia && Ia.css ? Xa(Ia.css) : "", document.head.appendChild(u), Ga(u, "override");
                        var s = Ua("wp-dark-mode--variables"),
                            l = Un(ja),
                            f = ja,
                            d = f.darkSchemeBackgroundColor,
                            h = f.darkSchemeTextColor,
                            p = f.lightSchemeBackgroundColor,
                            v = f.lightSchemeTextColor,
                            m = f.mode,
                            g = 0 === m ? p : d,
                            b = 0 === m ? v : h;
                        g = Bt(ot(g), ja), b = zt(ot(b), ja), s.textContent = [":root {", "  --wp-dark-mode-neutral-background: ".concat(g, ";"), "  --wp-dark-mode-neutral-text: ".concat(b, ";"), "  --wp-dark-mode-selection-background: ".concat(l.backgroundColorSelection, ";"), "  --wp-dark-mode-selection-text: ".concat(l.foregroundColorSelection, ";"), "}"].join("\n"), document.head.insertBefore(s, i.nextSibling), Ga(s, "variables");
                        var y = Ua("wp-dark-mode--root-vars");
                        document.head.insertBefore(y, s.nextSibling);
                        var w = !(Ia && Ia.disableStyleSheetsProxy),
                            S = !(Ia && Ia.disableCustomElementRegistryProxy);
                        document.dispatchEvent(new CustomEvent("__wp_dark_mode__cleanUp"));
                        var k = function(e) {
                            var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document.head || document).querySelector(".".concat(e));
                            return t || ((t = document.createElement("script")).classList.add("wp-dark-mode"), t.classList.add(e)), t
                        }("wp-dark-mode--proxy");
                        k.append("(".concat(Ca, ")(").concat(w, ", ").concat(S, ")")), k.remove(), $a.background = g, $a.text = b, $a.selectionBackground = l.backgroundColorSelection, $a.selectionText = l.foregroundColorSelection
                    }
                    var Qa = new Set;

                    function Ka(e) {
                        var t = Ua("wp-dark-mode--inline", e);
                        t.textContent = Cr(), e.insertBefore(t, e.firstChild);
                        var n = Ua("wp-dark-mode--override", e);
                        n.textContent = Ia && Ia.css ? Xa(Ia.css) : "", e.insertBefore(n, t.nextSibling);
                        var r = Ua("wp-dark-mode--invert", e);
                        Ia && Array.isArray(Ia.invert) && Ia.invert.length > 0 ? r.textContent = ["".concat(Ia.invert.join(", "), " {"), "    filter: ".concat(Xt(c(c({}, ja), {}, {
                            contrast: 0 === ja.mode ? ja.contrast : At(ja.contrast - 10, 0, 100)
                        })), " !important;"), "}"].join("\n") : r.textContent = "", e.insertBefore(r, n.nextSibling), Qa.add(e)
                    }

                    function Ya(e) {
                        var t = null === e.firstChild;
                        Ka(e), t && function(e) {
                            new MutationObserver((function(t, n) {
                                n.disconnect();
                                var r, a = m(t);
                                try {
                                    for (a.s(); !(r = a.n()).done;) {
                                        var o = r.value,
                                            i = o.type,
                                            u = o.removedNodes;
                                        if ("childList" === i) {
                                            var c, s = m(u);
                                            try {
                                                for (s.s(); !(c = s.n()).done;) {
                                                    var l = c.value,
                                                        f = l.nodeName,
                                                        d = l.className;
                                                    if ("STYLE" === f && ["wp-dark-mode wp-dark-mode-inline", "wp-dark-mode wp-dark-mode-override", "wp-dark-mode wp-dark-mode-invert"].includes(d)) return void Ka(e)
                                                }
                                            } catch (e) {
                                                s.e(e)
                                            } finally {
                                                s.f()
                                            }
                                        }
                                    }
                                } catch (e) {
                                    a.e(e)
                                } finally {
                                    a.f()
                                }
                            })).observe(e, {
                                childList: !0
                            })
                        }(e)
                    }

                    function Xa(e) {
                        return e.replace(/\${(.+?)}/g, (function(e, t) {
                            var n = ot(t);
                            return n ? function(e, t) {
                                return Nt(e, t, Ft)
                            }(n, ja) : t
                        }))
                    }

                    function Ja() {
                        var e = document.querySelector(".wp-dark-mode--fallback");
                        e && (e.textContent = "")
                    }
                    var Za = 0,
                        eo = new Set;

                    function to(e) {
                        var t = ++Za,
                            n = Zr(e, {
                                update: function() {
                                    var e = n.details({
                                        secondRound: !0
                                    });
                                    e && (Zn.addRulesForMatching(e.rules), Zn.matchVariablesAndDependents(), n.render(ja, qa))
                                },
                                loadingStart: function() {
                                    if (!de() || !Ma()) {
                                        eo.add(t), "Current amount of styles loading: ".concat(eo.size);
                                        var e = document.querySelector(".wp-dark-mode--fallback");
                                        e.textContent || (e.textContent = Hn(ja, {
                                            strict: !1
                                        }))
                                    }
                                },
                                loadingEnd: function() {
                                    eo.delete(t), "Removed loadingStyle ".concat(t, ", now awaiting: ").concat(eo.size), 0 === eo.size && de() && Ja()
                                }
                            });
                        return Oa.set(e, n), n
                    }

                    function no(e) {
                        var t = Oa.get(e);
                        t && (t.destroy(), Oa.delete(e))
                    }
                    var ro, ao = oe((function(e) {
                            Oa.forEach((function(e) {
                                return e.render(ja, qa)
                            })), Pa.forEach((function(e) {
                                return e.render(ja, qa)
                            })), e && e()
                        })),
                        oo = function() {
                            ao.cancel()
                        };

                    function io() {
                        0 !== eo.size || Ja()
                    }

                    function uo() {
                        ! function() {
                            oo();
                            var e = Qr(document).filter((function(e) {
                                return !Oa.has(e)
                            })).map((function(e) {
                                return to(e)
                            }));
                            e.map((function(e) {
                                return e.details({
                                    secondRound: !1
                                })
                            })).filter((function(e) {
                                return e && e.rules.length > 0
                            })).forEach((function(e) {
                                Zn.addRulesForMatching(e.rules)
                            })), Zn.matchVariablesAndDependents(), Zn.setOnRootVariableChange((function() {
                                var e = Ua("wp-dark-mode--root-vars");
                                Zn.putRootVars(e, ja)
                            }));
                            var t = Ua("wp-dark-mode--root-vars");
                            Zn.putRootVars(t, ja), Oa.forEach((function(e) {
                                return e.render(ja, qa)
                            })), 0 === eo.size && Ja(), e.forEach((function(e) {
                                return e.watch()
                            }));
                            var n = function(e) {
                                for (var t = [], n = 0, r = e.length; n < r; n++) t.push(e[n]);
                                return t
                            }(document.querySelectorAll(xr));
                            if (fe(document.documentElement, (function(e) {
                                    Ya(e.shadowRoot);
                                    var t = e.shadowRoot.querySelectorAll(xr);
                                    t.length > 0 && ae(n, t)
                                })), n.forEach((function(e) {
                                    return Vr(e, ja, Ba, qa)
                                })), so(document), Zn.matchVariablesAndDependents(), E) {
                                var r = Symbol(),
                                    a = function(e) {
                                        var t = e.detail,
                                            n = t.node,
                                            a = t.id,
                                            o = t.cssRules,
                                            i = t.entries;
                                        Array.isArray(i) ? (i.forEach((function(e) {
                                            var t = e[2];
                                            Zn.addRulesForMatching(t)
                                        })), Zn.matchVariablesAndDependents()) : o && (Zn.addRulesForMatching(o), ue(r, (function() {
                                            return Zn.matchVariablesAndDependents()
                                        }))), (Array.isArray(i) ? i : n && o ? [
                                            [n, a, o]
                                        ] : []).forEach((function(e) {
                                            var t = p(e, 3),
                                                n = t[0],
                                                r = t[1],
                                                a = t[2];
                                            Na.set(n, r), lo(n).updateCSS(a)
                                        }))
                                    };
                                document.addEventListener("__wp_dark_mode__adoptedStyleSheetsChange", a), vo.push((function() {
                                    return document.removeEventListener("__wp_dark_mode__adoptedStyleSheetsChange", a)
                                })), document.dispatchEvent(new CustomEvent("__wp_dark_mode__startAdoptedStyleSheetsWatcher"))
                            }
                        }(), ba(Array.from(Oa.keys()), (function(e) {
                                var t = e.created,
                                    n = e.updated,
                                    r = e.removed,
                                    a = e.moved,
                                    o = r,
                                    i = t.concat(n).concat(a).filter((function(e) {
                                        return !Oa.has(e)
                                    })),
                                    u = a.filter((function(e) {
                                        return Oa.has(e)
                                    }));
                                o.forEach((function(e) {
                                    return no(e)
                                }));
                                var c = i.map((function(e) {
                                    return to(e)
                                }));
                                c.map((function(e) {
                                    return e.details({
                                        secondRound: !1
                                    })
                                })).filter((function(e) {
                                    return e && e.rules.length > 0
                                })).forEach((function(e) {
                                    Zn.addRulesForMatching(e.rules)
                                })), Zn.matchVariablesAndDependents(), c.forEach((function(e) {
                                    return e.render(ja, qa)
                                })), c.forEach((function(e) {
                                    return e.watch()
                                })), u.forEach((function(e) {
                                    return Oa.get(e).restore()
                                }))
                            }), (function(e) {
                                Ya(e), so(e)
                            })),
                            function(e, t) {
                                Tr(document, e, t), fe(document.documentElement, (function(n) {
                                    Tr(n.shadowRoot, e, t)
                                }))
                            }((function(e) {
                                if (Vr(e, ja, Ba, qa), e === document.documentElement && (e.getAttribute("style") || "").includes("--")) {
                                    Zn.matchVariablesAndDependents();
                                    var t = Ua("wp-dark-mode--root-vars");
                                    Zn.putRootVars(t, ja)
                                }
                            }), (function(e) {
                                Ya(e);
                                var t = e.querySelectorAll(xr);
                                t.length > 0 && re(t, (function(e) {
                                    return Vr(e, ja, Ba, qa)
                                }))
                            })), pe(io)
                    }

                    function co() {
                        za(), Ma() || ja.immediateModify ? uo() : Ra(uo),
                            function(e) {
                                var t = document.querySelector(Pr);
                                t ? Fr(t, e) : (Nr && Nr.disconnect(), (Nr = new MutationObserver((function(t) {
                                    e: for (var n = 0; n < t.length; n++)
                                        for (var r = t[n].addedNodes, a = 0; a < r.length; a++) {
                                            var o = r[a];
                                            if (o instanceof HTMLMetaElement && o.name === Or) {
                                                Nr.disconnect(), Nr = null, Fr(o, e);
                                                break e
                                            }
                                        }
                                }))).observe(document.head, {
                                    childList: !0
                                }))
                            }(ja)
                    }

                    function so(e) {
                        if (E) lo(e).render(ja, qa);
                        else if (function(e) {
                                return Array.isArray(e.adoptedStyleSheets)
                            }(e)) {
                            e.adoptedStyleSheets.forEach((function(e) {
                                Zn.addRulesForMatching(e.cssRules)
                            }));
                            var t = Ea(e);
                            Pa.push(t), t.render(ja, qa), t.watch((function(e) {
                                e.forEach((function(e) {
                                    Zn.addRulesForMatching(e.cssRules)
                                })), Zn.matchVariablesAndDependents(), t.render(ja, qa)
                            }))
                        }
                    }

                    function lo(e) {
                        var t = Da.get(e);
                        return t || (t = function(e) {
                            var t, n = !1,
                                r = [],
                                a = !0,
                                o = new xa(e);

                            function i(e, i) {
                                t = e, a = i, Br().modifySheet({
                                    prepareSheet: function() {
                                        return o.replaceSync(""), o
                                    },
                                    sourceCSSRules: r,
                                    theme: e,
                                    ignoreImageAnalysis: !0,
                                    force: !1,
                                    isAsyncCancelled: function() {
                                        return n
                                    }
                                })
                            }
                            return {
                                render: i,
                                destroy: function() {
                                    n = !0
                                },
                                updateCSS: function(e) {
                                    r = e, t && a && i(t, a)
                                },
                                commands: function() {
                                    var e = o.getDeepCSSCommands();
                                    return o.clearDeepCSSCommands(), e
                                }
                            }
                        }((function() {
                            var n = function(e) {
                                if (Fa.has(e)) return Fa.get(e);
                                var t = Symbol();
                                return Fa.set(e, t), t
                            }(e);
                            ue(n, (function() {
                                var n, r = Na.get(e),
                                    a = null === (n = t) || void 0 === n ? void 0 : n.commands();
                                if (r && a) {
                                    var o = {
                                        id: r,
                                        commands: a
                                    };
                                    document.dispatchEvent(new CustomEvent("__wp_dark_mode__adoptedStyleSheetCommands", {
                                        detail: JSON.stringify(o)
                                    }))
                                }
                            }))
                        })), Da.set(e, t)), t
                    }

                    function fo() {
                        Oa.forEach((function(e) {
                            return e.pause()
                        })), re(Ha.values(), (function(e) {
                            return e.stop()
                        })), Ha.clear(), ya(), _r.forEach((function(e) {
                            return e.disconnect()
                        })), Ar.forEach((function(e) {
                            return e.disconnect()
                        })), _r.clear(), Ar.clear(), ve(io), ge.clear()
                    }

                    function ho() {
                        if (document.querySelector('meta[name="wp-dark-mode-lock"]')) return !0;
                        var e, t = document.querySelector('meta[name="wp-dark-mode"]');
                        return t ? t.content !== Va : ((e = document.createElement("meta")).name = "wp-dark-mode", e.content = Va, document.head.appendChild(e), (ro = new MutationObserver((function() {
                            document.querySelector('meta[name="wp-dark-mode-lock"]') && (ro.disconnect(), mo())
                        }))).observe(document.head, {
                            childList: !0,
                            subtree: !0
                        }), !1)
                    }

                    function po(e, t, n) {
                        if (ja = e, (Ia = t) ? (qa = Array.isArray(Ia.ignoreImageAnalysis) ? Ia.ignoreImageAnalysis : [], Ba = Array.isArray(Ia.ignoreInlineStyle) ? Ia.ignoreInlineStyle : []) : (qa = [], Ba = []), ja.immediateModify && (de = function() {
                                return !0
                            }), Wa = n, document.head) {
                            if (ho()) return void mo();
                            document.documentElement.setAttribute("data-wp-dark-mode-scheme", "dark"), co()
                        } else {
                            if (!E) {
                                var r = Ua("wp-dark-mode--fallback");
                                document.documentElement.appendChild(r), r.textContent = Hn(ja, {
                                    strict: !0
                                })
                            }
                            var a = new MutationObserver((function() {
                                if (document.head) {
                                    if (a.disconnect(), ho()) return void mo();
                                    co()
                                }
                            }));
                            a.observe(document, {
                                childList: !0,
                                subtree: !0
                            })
                        }
                    }
                    var vo = [];

                    function mo() {
                        document.documentElement.removeAttribute("data-wp-dark-mode-mode"), document.documentElement.removeAttribute("data-wp-dark-mode-scheme"), Zn.clear(), Le.clear(), La(), oo(), fo(), Xn(), rt.clear(), at.clear(), se(document.querySelector(".wp-dark-mode--fallback")), document.head && (function() {
                            Nr && (Nr.disconnect(), Nr = null);
                            var e = document.querySelector(Pr);
                            e && Dr && (e.content = Dr)
                        }(), se(document.head.querySelector(".wp-dark-mode--user-agent")), se(document.head.querySelector(".wp-dark-mode--text")), se(document.head.querySelector(".wp-dark-mode--invert")), se(document.head.querySelector(".wp-dark-mode--inline")), se(document.head.querySelector(".wp-dark-mode--override")), se(document.head.querySelector(".wp-dark-mode--variables")), se(document.head.querySelector(".wp-dark-mode--root-vars")), se(document.head.querySelector('meta[name="wp-dark-mode"]')), document.dispatchEvent(new CustomEvent("__wp_dark_mode__cleanUp")), se(document.head.querySelector(".wp-dark-mode--proxy"))), Qa.forEach((function(e) {
                            se(e.querySelector(".wp-dark-mode--inline")), se(e.querySelector(".wp-dark-mode--override"))
                        })), Qa.clear(), re(Oa.keys(), (function(e) {
                            return no(e)
                        })), eo.clear(), Jr.clear(), re(document.querySelectorAll(".wp-dark-mode"), se), Pa.forEach((function(e) {
                            return e.destroy()
                        })), Pa.splice(0), Da.forEach((function(e) {
                            return e.destroy()
                        })), Da.clear(), ro && ro.disconnect(), vo.forEach((function(e) {
                            return e()
                        })), vo.splice(0)
                    }

                    function go(e) {
                        if (!(e = (e = Ir(e)).trim())) return [];
                        var t = [],
                            n = yo(e),
                            r = bo(e, "{", "}", n),
                            a = 0;
                        return r.forEach((function(n) {
                            var r, o, i, u = e.substring(a, n.start).trim(),
                                c = e.substring(n.start + 1, n.end - 1);
                            if (u.startsWith("@")) {
                                var s = u.search(/[\s\(]/),
                                    l = {
                                        type: s < 0 ? u : u.substring(0, s),
                                        query: s < 0 ? "" : u.substring(s).trim(),
                                        rules: go(c)
                                    };
                                t.push(l)
                            } else {
                                var f = {
                                    selectors: (i = u, Re(i, ",", yo(i))),
                                    declarations: (r = c, o = [], Re(r, ";", yo(r)).forEach((function(e) {
                                        var t = e.indexOf(":");
                                        if (t > 0) {
                                            var n = e.indexOf("!important");
                                            o.push({
                                                property: e.substring(0, t).trim(),
                                                value: e.substring(t + 1, n > 0 ? n : e.length).trim(),
                                                important: n > 0
                                            })
                                        }
                                    })), o)
                                };
                                t.push(f)
                            }
                            a = n.end
                        })), t
                    }

                    function bo(e, t, n) {
                        for (var r, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [], o = [], i = 0; r = Ae(e, i, t, n, a);) o.push(r), i = r.end;
                        return o
                    }

                    function yo(e) {
                        var t = e.indexOf("'") < e.indexOf('"'),
                            n = t ? "'" : '"',
                            r = t ? '"' : "'",
                            a = bo(e, n, n);
                        return a.push.apply(a, v(bo(e, r, r, a))), a.push.apply(a, v(bo(e, "[", "]", a))), a.push.apply(a, v(bo(e, "(", ")", a))), a
                    }

                    function wo(e) {
                        return "selectors" in e
                    }

                    function So(e) {
                        return function(e) {
                            var t = [],
                                n = "    ";

                            function r(e, t) {
                                wo(e) ? o(e, t) : a(e, t)
                            }

                            function a(e, a) {
                                var o = e.type,
                                    i = e.query,
                                    u = e.rules;
                                t.push("".concat(a).concat(o, " ").concat(i, " {")), u.forEach((function(e) {
                                    return r(e, "".concat(a).concat(n))
                                })), t.push("".concat(a, "}"))
                            }

                            function o(e, r) {
                                var a = e.selectors,
                                    o = e.declarations,
                                    i = a.length - 1;
                                a.forEach((function(e, n) {
                                    t.push("".concat(r).concat(e).concat(n < i ? "," : " {"))
                                }));
                                var u = function(e) {
                                    var t = /^-[a-z]-/;
                                    return v(e).sort((function(e, n) {
                                        var r, a, o, i, u = e.property,
                                            c = n.property,
                                            s = null !== (r = null === (a = u.match(t)) || void 0 === a ? void 0 : a[0]) && void 0 !== r ? r : "",
                                            l = null !== (o = null === (i = c.match(t)) || void 0 === i ? void 0 : i[0]) && void 0 !== o ? o : "",
                                            f = s ? u.replace(t, "") : u,
                                            d = l ? c.replace(t, "") : c;
                                        return f === d ? s.localeCompare(l) : f.localeCompare(d)
                                    }))
                                }(o);
                                u.forEach((function(e) {
                                    var a = e.property,
                                        o = e.value,
                                        i = e.important;
                                    t.push("".concat(r).concat(n).concat(a, ": ").concat(o).concat(i ? " !important" : "", ";"))
                                })), t.push("".concat(r, "}"))
                            }
                            return ko(e), e.forEach((function(e) {
                                return r(e, "")
                            })), t.join("\n")
                        }(go(e))
                    }

                    function ko(e) {
                        for (var t = e.length - 1; t >= 0; t--) {
                            var n = e[t];
                            wo(n) ? 0 === n.declarations.length && e.splice(t, 1) : (ko(n.rules), 0 === n.rules.length && e.splice(t, 1))
                        }
                    }
                    var Eo = /url\(\"(blob\:.*?)\"\)/g;

                    function xo(e) {
                        return Co.apply(this, arguments)
                    }

                    function Co() {
                        return (Co = S(y().mark((function e(t) {
                            var n, r;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return n = [], xe(Eo, t, 1).forEach((function(e) {
                                            var t = P(e);
                                            n.push(t)
                                        })), e.next = 4, Promise.all(n);
                                    case 4:
                                        return r = e.sent, e.abrupt("return", t.replace(Eo, (function() {
                                            return 'url("'.concat(r.shift(), '")')
                                        })));
                                    case 6:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    var _o = "";

                    function Ao() {
                        return To.apply(this, arguments)
                    }

                    function To() {
                        return (To = S(y().mark((function e() {
                            var t, n, r, a;
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (n = function(e, n) {
                                                var r = document.querySelector(e);
                                                r && r.textContent && (t.push("/* ".concat(n, " */")), t.push(r.textContent), t.push(""))
                                            }, t = [_o], n(".wp-dark-mode--fallback", "Fallback Style"), n(".wp-dark-mode--user-agent", "User-Agent Style"), n(".wp-dark-mode--text", "Text Style"), n(".wp-dark-mode--invert", "Invert Style"), n(".wp-dark-mode--variables", "Variables Style"), r = [], document.querySelectorAll(".wp-dark-mode--sync").forEach((function(e) {
                                                re(e.sheet.cssRules, (function(e) {
                                                    e && e.cssText && r.push(e.cssText)
                                                }))
                                            })), !r.length) {
                                            e.next = 18;
                                            break
                                        }
                                        return a = So(r.join("\n")), t.push("/* Modified CSS */"), e.t0 = t, e.next = 15, xo(a);
                                    case 15:
                                        e.t1 = e.sent, e.t0.push.call(e.t0, e.t1), t.push("");
                                    case 18:
                                        return n(".wp-dark-mode--override", "Override Style"), e.abrupt("return", t.join("\n"));
                                    case 20:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    var Ro = !1,
                        Lo = function() {
                            try {
                                return window.self !== window.top
                            } catch (e) {
                                return !0
                            }
                        }();

                    function Mo() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                            n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                            r = c(c({}, ne), e);
                        if (r.engine !== $.dynamicTheme) throw new Error("Theme engine is not supported.");
                        if (po(r, t, Lo), Ro = !0, !n) {
                            var a = new CustomEvent("wp-dark-mode:enable", {
                                detail: {
                                    theme: r,
                                    colors: $a
                                }
                            });
                            document.dispatchEvent(a)
                        }
                    }

                    function Vo() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        if (mo(), Ro = !1, !e) {
                            var t = new CustomEvent("wp-dark-mode:disable");
                            document.dispatchEvent(t)
                        }
                    }
                    var Oo = matchMedia("(prefers-color-scheme: dark)"),
                        Po = {
                            themeOptions: null,
                            fixes: null
                        };

                    function Do() {
                        Oo.matches ? Mo(Po.themeOptions, Po.fixes, "auto" === window.DarkModeAuto) : Vo()
                    }

                    function No() {
                        return (No = S(y().mark((function e() {
                            return y().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.next = 2, Ao();
                                    case 2:
                                        return e.abrupt("return", e.sent);
                                    case 3:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })))).apply(this, arguments)
                    }
                    var Fo = function(e) {
                        U = e || B
                    };
                    e.auto = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        e ? (Po = {
                            themeOptions: e,
                            fixes: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null
                        }, Do(), R ? Oo.addEventListener("change", Do) : Oo.addListener(Do)) : (R ? Oo.removeEventListener("change", Do) : Oo.removeListener(Do), Vo());
                        var t = new CustomEvent("wp-dark-mode:auto");
                        document.dispatchEvent(t)
                    }, e.disable = Vo, e.enable = Mo, e.exportGeneratedCSS = function() {
                        return No.apply(this, arguments)
                    }, e.isEnabled = function() {
                        return Ro
                    }, e.setFetchMethod = Fo, e.colors = $a, Object.defineProperty(e, "__esModule", {
                        value: !0
                    })
                }, window.DarkModeAuto = o, "object" === k(t) ? i(t) : (r = [t], void 0 === (a = "function" == typeof(n = i) ? n.apply(t, r) : n) || (e.exports = a))
            }
        },
        t = {};
    (function n(r) {
        var a = t[r];
        if (void 0 !== a) return a.exports;
        var o = t[r] = {
            exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.exports
    })(35)
})();